export const russianCities = [
    {
    "coords": {
            "lat": "52.65",
            "lon": "90.08333"
        },
        "district": "Сибирский",
        "name": "Абаза",
        "population": 14816,
        "subject": "Хакасия"
    },
    {
    "coords": {
    "lat": "53.71667",
    "lon": "91.41667"
    },
    "district": "Сибирский",
    "name": "Абакан",
    "population": 187239,
    "subject": "Хакасия"
    },
    {
    "coords": {
    "lat": "53.68333",
    "lon": "53.65"
    },
    "district": "Приволжский",
    "name": "Абдулино",
    "population": 18420,
    "subject": "Оренбургская область"
    },
    {
    "coords": {
    "lat": "44.86667",
    "lon": "38.16667"
    },
    "district": "Южный",
    "name": "Абинск",
    "population": 39186,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "55.9",
    "lon": "53.93333"
    },
    "district": "Приволжский",
    "name": "Агидель",
    "population": 13935,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "56.51667",
    "lon": "52.98333"
    },
    "district": "Приволжский",
    "name": "Агрыз",
    "population": 19743,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "44.884525",
    "lon": "39.19202"
    },
    "district": "Южный",
    "name": "Адыгейск",
    "population": 12877,
    "subject": "Адыгея"
    },
    {
    "coords": {
    "lat": "54.85",
    "lon": "53.06667"
    },
    "district": "Приволжский",
    "name": "Азнакаево",
    "population": 33728,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "47.1",
    "lon": "39.41667"
    },
    "district": "Южный",
    "name": "Азов",
    "population": 79857,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "51.16667",
    "lon": "90.6"
    },
    "district": "Сибирский",
    "name": "Ак-Довурак",
    "population": 13769,
    "subject": "Тыва"
    },
    {
    "coords": {
    "lat": "47.26667",
    "lon": "39.86667"
    },
    "district": "Южный",
    "name": "Аксай",
    "population": 46631,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "43.04167",
    "lon": "44.21056"
    },
    "district": "Северо-Кавказский",
    "name": "Алагир",
    "population": 19678,
    "subject": "Северная Осетия"
    },
    {
    "coords": {
    "lat": "57.85",
    "lon": "61.7"
    },
    "district": "Уральский",
    "name": "Алапаевск",
    "population": 36951,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "54.85",
    "lon": "46.58333"
    },
    "district": "Приволжский",
    "name": "Алатырь",
    "population": 33035,
    "subject": "Чувашия"
    },
    {
    "coords": {
    "lat": "58.6",
    "lon": "125.38333"
    },
    "district": "Дальневосточный",
    "name": "Алдан",
    "population": 20366,
    "subject": "Якутия"
    },
    {
    "coords": {
    "lat": "52.5",
    "lon": "82.78333"
    },
    "district": "Сибирский",
    "name": "Алейск",
    "population": 28434,
    "subject": "Алтайский край"
    },
    {
    "coords": {
    "lat": "56.39361",
    "lon": "38.715"
    },
    "district": "Центральный",
    "name": "Александров",
    "population": 57073,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "50.9",
    "lon": "142.15"
    },
    "district": "Дальневосточный",
    "name": "Александровск-Сахалинский",
    "population": 9106,
    "subject": "Сахалинская область"
    },
    {
    "coords": {
    "lat": "59.16667",
    "lon": "57.58333"
    },
    "district": "Приволжский",
    "name": "Александровск",
    "population": 11739,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "50.63",
    "lon": "38.68639"
    },
    "district": "Центральный",
    "name": "Алексеевка",
    "population": 37583,
    "subject": "Белгородская область"
    },
    {
    "coords": {
    "lat": "54.5",
    "lon": "37.06667"
    },
    "district": "Центральный",
    "name": "Алексин",
    "population": 57102,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "55.55",
    "lon": "98.66667"
    },
    "district": "Сибирский",
    "name": "Алзамай",
    "population": 5693,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "44.41972",
    "lon": "34.04306"
    },
    "district": "Южный",
    "name": "Алупка",
    "population": 8087,
    "subject": "Крым"
    },
    {
    "coords": {
    "lat": "44.66722",
    "lon": "34.39778"
    },
    "district": "Южный",
    "name": "Алушта",
    "population": 30194,
    "subject": "Крым"
    },
    {
    "coords": {
    "lat": "54.9",
    "lon": "52.3"
    },
    "district": "Приволжский",
    "name": "Альметьевск",
    "population": 158019,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "50.21667",
    "lon": "136.9"
    },
    "district": "Дальневосточный",
    "name": "Амурск",
    "population": 38694,
    "subject": "Хабаровский край"
    },
    {
    "coords": {
    "lat": "64.73333",
    "lon": "177.51667"
    },
    "district": "Дальневосточный",
    "name": "Анадырь",
    "population": 15240,
    "subject": "Чукотский АО"
    },
    {
    "coords": {
    "lat": "44.893857",
    "lon": "37.317481"
    },
    "district": "Южный",
    "name": "Анапа",
    "population": 94340,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "52.56667",
    "lon": "103.91667"
    },
    "district": "Сибирский",
    "name": "Ангарск",
    "population": 222855,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "56.65",
    "lon": "32.26667"
    },
    "district": "Центральный",
    "name": "Андреаполь",
    "population": 6703,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "56.08333",
    "lon": "86.03333"
    },
    "district": "Сибирский",
    "name": "Анжеро-Судженск",
    "population": 66933,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "46.71667",
    "lon": "142.51667"
    },
    "district": "Дальневосточный",
    "name": "Анива",
    "population": 9326,
    "subject": "Сахалинская область"
    },
    {
    "coords": {
    "lat": "67.5675",
    "lon": "33.39333"
    },
    "district": "Северо-Западный",
    "name": "Апатиты",
    "population": 53847,
    "subject": "Мурманская область"
    },
    {
    "coords": {
    "lat": "55.53333",
    "lon": "37.05"
    },
    "district": "Центральный",
    "name": "Апрелевка",
    "population": 32424,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "44.46083",
    "lon": "39.74056"
    },
    "district": "Южный",
    "name": "Апшеронск",
    "population": 39162,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "56.7",
    "lon": "60.83333"
    },
    "district": "Уральский",
    "name": "Арамиль",
    "population": 15791,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "43.29222",
    "lon": "45.87722"
    },
    "district": "Северо-Кавказский",
    "name": "Аргун",
    "population": 40290,
    "subject": "Чечня"
    },
    {
    "coords": {
    "lat": "54.85",
    "lon": "46.23333"
    },
    "district": "Приволжский",
    "name": "Ардатов",
    "population": 8150,
    "subject": "Мордовия"
    },
    {
    "coords": {
    "lat": "43.17278",
    "lon": "44.29222"
    },
    "district": "Северо-Кавказский",
    "name": "Ардон",
    "population": 19274,
    "subject": "Северная Осетия"
    },
    {
    "coords": {
    "lat": "55.38333",
    "lon": "43.8"
    },
    "district": "Приволжский",
    "name": "Арзамас",
    "population": 103396,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "51.93333",
    "lon": "43.5"
    },
    "district": "Приволжский",
    "name": "Аркадак",
    "population": 11340,
    "subject": "Саратовская область"
    },
    {
    "coords": {
    "lat": "45",
    "lon": "41.11667"
    },
    "district": "Южный",
    "name": "Армавир",
    "population": 187215,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "46.10694",
    "lon": "33.69306"
    },
    "district": "Южный",
    "name": "Армянск",
    "population": 21239,
    "subject": "Крым"
    },
    {
    "coords": {
    "lat": "44.16667",
    "lon": "133.26667"
    },
    "district": "Дальневосточный",
    "name": "Арсеньев",
    "population": 51723,
    "subject": "Приморский край"
    },
    {
    "coords": {
    "lat": "56.09056",
    "lon": "49.87639"
    },
    "district": "Приволжский",
    "name": "Арск",
    "population": 20219,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "43.35",
    "lon": "132.18333"
    },
    "district": "Дальневосточный",
    "name": "Артём",
    "population": 104926,
    "subject": "Приморский край"
    },
    {
    "coords": {
    "lat": "54.35",
    "lon": "93.43333"
    },
    "district": "Сибирский",
    "name": "Артёмовск",
    "population": 1492,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "57.33639",
    "lon": "61.89194"
    },
    "district": "Уральский",
    "name": "Артёмовский",
    "population": 29754,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "64.55",
    "lon": "40.53333"
    },
    "district": "Северо-Западный",
    "name": "Архангельск",
    "population": 344927,
    "subject": "Архангельская область"
    },
    {
    "coords": {
    "lat": "57.01027679",
    "lon": "61.45639038"
    },
    "district": "Уральский",
    "name": "Асбест",
    "population": 62285,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "57",
    "lon": "86.15"
    },
    "district": "Сибирский",
    "name": "Асино",
    "population": 24442,
    "subject": "Томская область"
    },
    {
    "coords": {
    "lat": "46.33333",
    "lon": "48.03333"
    },
    "district": "Южный",
    "name": "Астрахань",
    "population": 524371,
    "subject": "Астраханская область"
    },
    {
    "coords": {
    "lat": "51.86667",
    "lon": "45"
    },
    "district": "Приволжский",
    "name": "Аткарск",
    "population": 23660,
    "subject": "Саратовская область"
    },
    {
    "coords": {
    "lat": "48.28333",
    "lon": "46.16667"
    },
    "district": "Южный",
    "name": "Ахтубинск",
    "population": 36127,
    "subject": "Астраханская область"
    },
    {
    "coords": {
    "lat": "56.26667",
    "lon": "90.5"
    },
    "district": "Сибирский",
    "name": "Ачинск",
    "population": 104850,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "55",
    "lon": "57.25"
    },
    "district": "Уральский",
    "name": "Аша",
    "population": 28722,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "59.38333",
    "lon": "35.95"
    },
    "district": "Северо-Западный",
    "name": "Бабаево",
    "population": 11416,
    "subject": "Вологодская область"
    },
    {
    "coords": {
    "lat": "51.71667",
    "lon": "105.86667"
    },
    "district": "Сибирский",
    "name": "Бабушкин",
    "population": 4385,
    "subject": "Бурятия"
    },
    {
    "coords": {
    "lat": "54.4",
    "lon": "53.25"
    },
    "district": "Приволжский",
    "name": "Бавлы",
    "population": 21794,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "54.38333",
    "lon": "20.63333"
    },
    "district": "Северо-Западный",
    "name": "Багратионовск",
    "population": 6401,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "51.51722",
    "lon": "104.15611"
    },
    "district": "Сибирский",
    "name": "Байкальск",
    "population": 12541,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "52.58333",
    "lon": "58.31667"
    },
    "district": "Приволжский",
    "name": "Баймак",
    "population": 17090,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "54.93333",
    "lon": "58.8"
    },
    "district": "Уральский",
    "name": "Бакал",
    "population": 18429,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "43.683333",
    "lon": "43.533333"
    },
    "district": "Северо-Кавказский",
    "name": "Баксан",
    "population": 38645,
    "subject": "Кабардино-Балкария"
    },
    {
    "coords": {
    "lat": "55.18333",
    "lon": "36.65"
    },
    "district": "Центральный",
    "name": "Балабаново",
    "population": 25861,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "44.5",
    "lon": "33.6"
    },
    "district": "Южный",
    "name": "Балаклава",
    "population": 34427,
    "subject": "Севастополь"
    },
    {
    "coords": {
    "lat": "52.03333",
    "lon": "47.78333"
    },
    "district": "Приволжский",
    "name": "Балаково",
    "population": 186012,
    "subject": "Саратовская область"
    },
    {
    "coords": {
    "lat": "56.48083",
    "lon": "43.54028"
    },
    "district": "Приволжский",
    "name": "Балахна",
    "population": 48122,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "55.8",
    "lon": "37.93333"
    },
    "district": "Центральный",
    "name": "Балашиха",
    "population": 507307,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "51.55",
    "lon": "43.16667"
    },
    "district": "Приволжский",
    "name": "Балашов",
    "population": 74981,
    "subject": "Саратовская область"
    },
    {
    "coords": {
    "lat": "51.57694",
    "lon": "116.64917"
    },
    "district": "Сибирский",
    "name": "Балей",
    "population": 10630,
    "subject": "Забайкальский край"
    },
    {
    "coords": {
    "lat": "54.65",
    "lon": "19.91667"
    },
    "district": "Северо-Западный",
    "name": "Балтийск",
    "population": 33946,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "55.35",
    "lon": "78.35"
    },
    "district": "Сибирский",
    "name": "Барабинск",
    "population": 28546,
    "subject": "Новосибирская область"
    },
    {
    "coords": {
    "lat": "53.347361",
    "lon": "83.77833"
    },
    "district": "Сибирский",
    "name": "Барнаул",
    "population": 631124,
    "subject": "Алтайский край"
    },
    {
    "coords": {
    "lat": "53.65",
    "lon": "47.11667"
    },
    "district": "Приволжский",
    "name": "Барыш",
    "population": 15408,
    "subject": "Ульяновская область"
    },
    {
    "coords": {
    "lat": "47.13333",
    "lon": "39.75"
    },
    "district": "Южный",
    "name": "Батайск",
    "population": 127444,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "44.75278",
    "lon": "33.86083"
    },
    "district": "Южный",
    "name": "Бахчисарай",
    "population": 26090,
    "subject": "Крым"
    },
    {
    "coords": {
    "lat": "57.78333",
    "lon": "36.7"
    },
    "district": "Центральный",
    "name": "Бежецк",
    "population": 20097,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "48.17472",
    "lon": "40.79306"
    },
    "district": "Южный",
    "name": "Белая Калитва",
    "population": 38739,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "58.83333",
    "lon": "50.85"
    },
    "district": "Приволжский",
    "name": "Белая Холуница",
    "population": 9994,
    "subject": "Кировская область"
    },
    {
    "coords": {
    "lat": "50.6",
    "lon": "36.6"
    },
    "district": "Центральный",
    "name": "Белгород",
    "population": 391702,
    "subject": "Белгородская область"
    },
    {
    "coords": {
    "lat": "54.1",
    "lon": "54.13333"
    },
    "district": "Приволжский",
    "name": "Белебей",
    "population": 59093,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "52.96667",
    "lon": "43.41667"
    },
    "district": "Приволжский",
    "name": "Белинский",
    "population": 7566,
    "subject": "Пензенская область"
    },
    {
    "coords": {
    "lat": "54.41667",
    "lon": "86.3"
    },
    "district": "Сибирский",
    "name": "Белово",
    "population": 70611,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "50.91667",
    "lon": "128.48333"
    },
    "district": "Дальневосточный",
    "name": "Белогорск",
    "population": 64502,
    "subject": "Амурская область"
    },
    {
    "coords": {
    "lat": "45.05444",
    "lon": "34.60222"
    },
    "district": "Южный",
    "name": "Белогорск",
    "population": 16298,
    "subject": "Крым"
    },
    {
    "coords": {
    "lat": "60.03333",
    "lon": "37.78333"
    },
    "district": "Северо-Западный",
    "name": "Белозерск",
    "population": 8464,
    "subject": "Вологодская область"
    },
    {
    "coords": {
    "lat": "52",
    "lon": "84.98333"
    },
    "district": "Сибирский",
    "name": "Белокуриха",
    "population": 15128,
    "subject": "Алтайский край"
    },
    {
    "coords": {
    "lat": "64.51667",
    "lon": "34.76667"
    },
    "district": "Северо-Западный",
    "name": "Беломорск",
    "population": 9036,
    "subject": "Карелия"
    },
    {
    "coords": {
    "lat": "55.46139",
    "lon": "38.44222"
    },
    "district": "Центральный",
    "name": "Белоозёрский",
    "population": 17674,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "53.96667",
    "lon": "58.4"
    },
    "district": "Приволжский",
    "name": "Белорецк",
    "population": 64479,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "44.76667",
    "lon": "39.86667"
    },
    "district": "Южный",
    "name": "Белореченск",
    "population": 51405,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "55.09167",
    "lon": "36.66667"
    },
    "district": "Центральный",
    "name": "Белоусово",
    "population": 10695,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "63.71667",
    "lon": "66.66667"
    },
    "district": "Уральский",
    "name": "Белоярский",
    "population": 19797,
    "subject": "Ханты-Мансийский АО"
    },
    {
    "coords": {
    "lat": "55.83333",
    "lon": "32.93333"
    },
    "district": "Центральный",
    "name": "Белый",
    "population": 3057,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "53.8",
    "lon": "36.13333"
    },
    "district": "Центральный",
    "name": "Белёв",
    "population": 12484,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "54.75",
    "lon": "83.1"
    },
    "district": "Сибирский",
    "name": "Бердск",
    "population": 103561,
    "subject": "Новосибирская область"
    },
    {
    "coords": {
    "lat": "59.40806",
    "lon": "56.80528"
    },
    "district": "Приволжский",
    "name": "Березники",
    "population": 137091,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "55.66667",
    "lon": "86.25"
    },
    "district": "Сибирский",
    "name": "Берёзовский",
    "population": 44932,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "56.9",
    "lon": "60.8"
    },
    "district": "Уральский",
    "name": "Берёзовский",
    "population": 60334,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "43.18889",
    "lon": "44.521691"
    },
    "district": "Северо-Кавказский",
    "name": "Беслан",
    "population": 37400,
    "subject": "Северная Осетия"
    },
    {
    "coords": {
    "lat": "52.51667",
    "lon": "85.16667"
    },
    "district": "Сибирский",
    "name": "Бийск",
    "population": 198433,
    "subject": "Алтайский край"
    },
    {
    "coords": {
    "lat": "46.81667",
    "lon": "134.25"
    },
    "district": "Дальневосточный",
    "name": "Бикин",
    "population": 16026,
    "subject": "Хабаровский край"
    },
    {
    "coords": {
    "lat": "68.05",
    "lon": "166.45"
    },
    "district": "Дальневосточный",
    "name": "Билибино",
    "population": 5366,
    "subject": "Чукотский АО"
    },
    {
    "coords": {
    "lat": "48.78333",
    "lon": "132.93333"
    },
    "district": "Дальневосточный",
    "name": "Биробиджан",
    "population": 70433,
    "subject": "Еврейская АО"
    },
    {
    "coords": {
    "lat": "55.41667",
    "lon": "55.53333"
    },
    "district": "Приволжский",
    "name": "Бирск",
    "population": 46245,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "55.95",
    "lon": "97.81667"
    },
    "district": "Сибирский",
    "name": "Бирюсинск",
    "population": 8401,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "50.65",
    "lon": "38.4"
    },
    "district": "Центральный",
    "name": "Бирюч",
    "population": 7409,
    "subject": "Белгородская область"
    },
    {
    "coords": {
    "lat": "50.25778",
    "lon": "127.53639"
    },
    "district": "Дальневосточный",
    "name": "Благовещенск",
    "population": 225757,
    "subject": "Амурская область"
    },
    {
    "coords": {
    "lat": "55.03333",
    "lon": "55.98333"
    },
    "district": "Приволжский",
    "name": "Благовещенск",
    "population": 34656,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "45.1029039",
    "lon": "43.4251513"
    },
    "district": "Северо-Кавказский",
    "name": "Благодарный",
    "population": 30333,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "51.09444",
    "lon": "40.03222"
    },
    "district": "Центральный",
    "name": "Бобров",
    "population": 19842,
    "subject": "Воронежская область"
    },
    {
    "coords": {
    "lat": "56.78333",
    "lon": "62.05"
    },
    "district": "Уральский",
    "name": "Богданович",
    "population": 29309,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "53.76667",
    "lon": "38.13333"
    },
    "district": "Центральный",
    "name": "Богородицк",
    "population": 30199,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "56.09972",
    "lon": "43.50722"
    },
    "district": "Приволжский",
    "name": "Богородск",
    "population": 33244,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "56.2",
    "lon": "89.51667"
    },
    "district": "Сибирский",
    "name": "Боготол",
    "population": 19218,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "49.93333",
    "lon": "40.55"
    },
    "district": "Центральный",
    "name": "Богучар",
    "population": 10975,
    "subject": "Воронежская область"
    },
    {
    "coords": {
    "lat": "57.85",
    "lon": "114.2"
    },
    "district": "Сибирский",
    "name": "Бодайбо",
    "population": 11477,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "59.473576",
    "lon": "33.847675"
    },
    "district": "Северо-Западный",
    "name": "Бокситогорск",
    "population": 14973,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "54.96667",
    "lon": "49.03333"
    },
    "district": "Приволжский",
    "name": "Болгар",
    "population": 8139,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "57.87083",
    "lon": "34.07361"
    },
    "district": "Центральный",
    "name": "Бологое",
    "population": 20178,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "55.66667",
    "lon": "84.4"
    },
    "district": "Сибирский",
    "name": "Болотное",
    "population": 15344,
    "subject": "Новосибирская область"
    },
    {
    "coords": {
    "lat": "54.08333",
    "lon": "37.81667"
    },
    "district": "Центральный",
    "name": "Болохово",
    "population": 8738,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "53.45",
    "lon": "36"
    },
    "district": "Центральный",
    "name": "Болхов",
    "population": 10685,
    "subject": "Орловская область"
    },
    {
    "coords": {
    "lat": "43.11667",
    "lon": "132.35"
    },
    "district": "Дальневосточный",
    "name": "Большой Камень",
    "population": 38685,
    "subject": "Приморский край"
    },
    {
    "coords": {
    "lat": "56.36028",
    "lon": "44.05917"
    },
    "district": "Приволжский",
    "name": "Бор",
    "population": 76732,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "50.38333",
    "lon": "116.53333"
    },
    "district": "Сибирский",
    "name": "Борзя",
    "population": 29387,
    "subject": "Забайкальский край"
    },
    {
    "coords": {
    "lat": "51.36667",
    "lon": "42.08333"
    },
    "district": "Центральный",
    "name": "Борисоглебск",
    "population": 58742,
    "subject": "Воронежская область"
    },
    {
    "coords": {
    "lat": "58.38694",
    "lon": "33.91139"
    },
    "district": "Северо-Западный",
    "name": "Боровичи",
    "population": 48858,
    "subject": "Новгородская область"
    },
    {
    "coords": {
    "lat": "55.2",
    "lon": "36.48333"
    },
    "district": "Центральный",
    "name": "Боровск",
    "population": 10222,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "55.9",
    "lon": "94.9"
    },
    "district": "Сибирский",
    "name": "Бородино",
    "population": 16005,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "56.15",
    "lon": "101.63"
    },
    "district": "Сибирский",
    "name": "Братск",
    "population": 225037,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "55.42278",
    "lon": "38.25889"
    },
    "district": "Центральный",
    "name": "Бронницы",
    "population": 22014,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "53.25",
    "lon": "34.36667"
    },
    "district": "Центральный",
    "name": "Брянск",
    "population": 399579,
    "subject": "Брянская область"
    },
    {
    "coords": {
    "lat": "54.53333",
    "lon": "52.78333"
    },
    "district": "Приволжский",
    "name": "Бугульма",
    "population": 81678,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "53.61667",
    "lon": "52.41667"
    },
    "district": "Приволжский",
    "name": "Бугуруслан",
    "population": 47714,
    "subject": "Оренбургская область"
    },
    {
    "coords": {
    "lat": "44.79",
    "lon": "44.14"
    },
    "district": "Северо-Кавказский",
    "name": "Будённовск",
    "population": 60504,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "52.76667",
    "lon": "52.26667"
    },
    "district": "Приволжский",
    "name": "Бузулук",
    "population": 86042,
    "subject": "Оренбургская область"
    },
    {
    "coords": {
    "lat": "54.96667",
    "lon": "48.28333"
    },
    "district": "Приволжский",
    "name": "Буинск",
    "population": 20093,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "58.48333",
    "lon": "41.51667"
    },
    "district": "Центральный",
    "name": "Буй",
    "population": 22960,
    "subject": "Костромская область"
    },
    {
    "coords": {
    "lat": "42.81667",
    "lon": "47.11667"
    },
    "district": "Северо-Кавказский",
    "name": "Буйнакск",
    "population": 66422,
    "subject": "Дагестан"
    },
    {
    "coords": {
    "lat": "50.825",
    "lon": "40.58889"
    },
    "district": "Центральный",
    "name": "Бутурлиновка",
    "population": 23627,
    "subject": "Воронежская область"
    },
    {
    "coords": {
    "lat": "57.96667",
    "lon": "33.25"
    },
    "district": "Северо-Западный",
    "name": "Валдай",
    "population": 13800,
    "subject": "Новгородская область"
    },
    {
    "coords": {
    "lat": "50.18333",
    "lon": "38.11667"
    },
    "district": "Центральный",
    "name": "Валуйки",
    "population": 34283,
    "subject": "Белгородская область"
    },
    {
    "coords": {
    "lat": "55.6",
    "lon": "31.2"
    },
    "district": "Центральный",
    "name": "Велиж",
    "population": 6639,
    "subject": "Смоленская область"
    },
    {
    "coords": {
    "lat": "56.35",
    "lon": "30.51667"
    },
    "district": "Северо-Западный",
    "name": "Великие Луки",
    "population": 90485,
    "subject": "Псковская область"
    },
    {
    "coords": {
    "lat": "58.525",
    "lon": "31.275"
    },
    "district": "Северо-Западный",
    "name": "Великий Новгород",
    "population": 225019,
    "subject": "Новгородская область"
    },
    {
    "coords": {
    "lat": "60.75889",
    "lon": "46.30389"
    },
    "district": "Северо-Западный",
    "name": "Великий Устюг",
    "population": 31078,
    "subject": "Вологодская область"
    },
    {
    "coords": {
    "lat": "61.06667",
    "lon": "42.1"
    },
    "district": "Северо-Западный",
    "name": "Вельск",
    "population": 22217,
    "subject": "Архангельская область"
    },
    {
    "coords": {
    "lat": "54.35",
    "lon": "38.26667"
    },
    "district": "Центральный",
    "name": "Венёв",
    "population": 13691,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "58.06667",
    "lon": "54.65"
    },
    "district": "Приволжский",
    "name": "Верещагино",
    "population": 20935,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "55.33333",
    "lon": "36.18333"
    },
    "district": "Центральный",
    "name": "Верея",
    "population": 5061,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "53.88333",
    "lon": "59.21667"
    },
    "district": "Уральский",
    "name": "Верхнеуральск",
    "population": 9141,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "57.38333",
    "lon": "59.93333"
    },
    "district": "Уральский",
    "name": "Верхний Тагил",
    "population": 10428,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "56.05",
    "lon": "60.23333"
    },
    "district": "Уральский",
    "name": "Верхний Уфалей",
    "population": 26444,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "56.96667",
    "lon": "60.58333"
    },
    "district": "Уральский",
    "name": "Верхняя Пышма",
    "population": 74262,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "58.05",
    "lon": "60.55"
    },
    "district": "Уральский",
    "name": "Верхняя Салда",
    "population": 41026,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "58.3574333",
    "lon": "59.8224444"
    },
    "district": "Уральский",
    "name": "Верхняя Тура",
    "population": 8862,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "58.86667",
    "lon": "60.8"
    },
    "district": "Уральский",
    "name": "Верхотурье",
    "population": 8528,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "67.55",
    "lon": "133.38333"
    },
    "district": "Дальневосточный",
    "name": "Верхоянск",
    "population": 1095,
    "subject": "Якутия"
    },
    {
    "coords": {
    "lat": "58.65",
    "lon": "37.26667"
    },
    "district": "Центральный",
    "name": "Весьегонск",
    "population": 5846,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "57.85556",
    "lon": "45.78111"
    },
    "district": "Приволжский",
    "name": "Ветлуга",
    "population": 8258,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "55.55",
    "lon": "37.7"
    },
    "district": "Центральный",
    "name": "Видное",
    "population": 78635,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "63.75",
    "lon": "121.61667"
    },
    "district": "Дальневосточный",
    "name": "Вилюйск",
    "population": 11319,
    "subject": "Якутия"
    },
    {
    "coords": {
    "lat": "52.93333",
    "lon": "158.4"
    },
    "district": "Дальневосточный",
    "name": "Вилючинск",
    "population": 22522,
    "subject": "Камчатский край"
    },
    {
    "coords": {
    "lat": "56.11667",
    "lon": "101.16667"
    },
    "district": "Сибирский",
    "name": "Вихоревка",
    "population": 20708,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "57.2",
    "lon": "41.91667"
    },
    "district": "Центральный",
    "name": "Вичуга",
    "population": 32971,
    "subject": "Ивановская область"
    },
    {
    "coords": {
    "lat": "43.11667",
    "lon": "131.9"
    },
    "district": "Дальневосточный",
    "name": "Владивосток",
    "population": 600871,
    "subject": "Приморский край"
    },
    {
    "coords": {
    "lat": "43.01667",
    "lon": "44.683315"
    },
    "district": "Северо-Кавказский",
    "name": "Владикавказ",
    "population": 301543,
    "subject": "Северная Осетия"
    },
    {
    "coords": {
    "lat": "56.13333",
    "lon": "40.41667"
    },
    "district": "Центральный",
    "name": "Владимир",
    "population": 352347,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "48.71167",
    "lon": "44.51389"
    },
    "district": "Южный",
    "name": "Волгоград",
    "population": 1004763,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "47.54",
    "lon": "42.20722"
    },
    "district": "Южный",
    "name": "Волгодонск",
    "population": 169953,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "57.43333",
    "lon": "41.16667"
    },
    "district": "Центральный",
    "name": "Волгореченск",
    "population": 16111,
    "subject": "Костромская область"
    },
    {
    "coords": {
    "lat": "55.86667",
    "lon": "48.35"
    },
    "district": "Приволжский",
    "name": "Волжск",
    "population": 52703,
    "subject": "Марий Эл"
    },
    {
    "coords": {
    "lat": "48.78333",
    "lon": "44.76667"
    },
    "district": "Южный",
    "name": "Волжский",
    "population": 323853,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "59.21667",
    "lon": "39.9"
    },
    "district": "Северо-Западный",
    "name": "Вологда",
    "population": 308530,
    "subject": "Вологодская область"
    },
    {
    "coords": {
    "lat": "56.23333",
    "lon": "43.2"
    },
    "district": "Приволжский",
    "name": "Володарск",
    "population": 9875,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "56.03333",
    "lon": "35.95"
    },
    "district": "Центральный",
    "name": "Волоколамск",
    "population": 18368,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "59.447275",
    "lon": "29.484819"
    },
    "district": "Северо-Западный",
    "name": "Волосово",
    "population": 11621,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "59.91667",
    "lon": "32.35"
    },
    "district": "Северо-Западный",
    "name": "Волхов",
    "population": 43969,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "59.93333",
    "lon": "60.05"
    },
    "district": "Уральский",
    "name": "Волчанск",
    "population": 8458,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "52.05",
    "lon": "47.38333"
    },
    "district": "Приволжский",
    "name": "Вольск",
    "population": 60948,
    "subject": "Саратовская область"
    },
    {
    "coords": {
    "lat": "67.5",
    "lon": "64.03333"
    },
    "district": "Северо-Западный",
    "name": "Воркута",
    "population": 52292,
    "subject": "Коми"
    },
    {
    "coords": {
    "lat": "51.67167",
    "lon": "39.21056"
    },
    "district": "Центральный",
    "name": "Воронеж",
    "population": 1050602,
    "subject": "Воронежская область"
    },
    {
    "coords": {
    "lat": "55.98333",
    "lon": "43.26667"
    },
    "district": "Приволжский",
    "name": "Ворсма",
    "population": 10120,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "55.32333",
    "lon": "38.68056"
    },
    "district": "Центральный",
    "name": "Воскресенск",
    "population": 92196,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "57.05",
    "lon": "54"
    },
    "district": "Приволжский",
    "name": "Воткинск",
    "population": 96861,
    "subject": "Удмуртия"
    },
    {
    "coords": {
    "lat": "60.021321",
    "lon": "30.654084"
    },
    "district": "Северо-Западный",
    "name": "Всеволожск",
    "population": 75660,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "63.86667",
    "lon": "57.31667"
    },
    "district": "Северо-Западный",
    "name": "Вуктыл",
    "population": 9671,
    "subject": "Коми"
    },
    {
    "coords": {
    "lat": "60.710496",
    "lon": "28.749781"
    },
    "district": "Северо-Западный",
    "name": "Выборг",
    "population": 74054,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "55.31944",
    "lon": "42.17306"
    },
    "district": "Приволжский",
    "name": "Выкса",
    "population": 52892,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "56.31667",
    "lon": "36.55"
    },
    "district": "Центральный",
    "name": "Высоковск",
    "population": 10306,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "60.625604",
    "lon": "28.568277"
    },
    "district": "Северо-Западный",
    "name": "Высоцк",
    "population": 1074,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "61",
    "lon": "36.45"
    },
    "district": "Северо-Западный",
    "name": "Вытегра",
    "population": 10116,
    "subject": "Вологодская область"
    },
    {
    "coords": {
    "lat": "57.58333",
    "lon": "34.56667"
    },
    "district": "Центральный",
    "name": "Вышний Волочёк",
    "population": 44722,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "47.53333",
    "lon": "134.75"
    },
    "district": "Дальневосточный",
    "name": "Вяземский",
    "population": 12969,
    "subject": "Хабаровский край"
    },
    {
    "coords": {
    "lat": "56.24333",
    "lon": "42.12917"
    },
    "district": "Центральный",
    "name": "Вязники",
    "population": 33769,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "55.21028",
    "lon": "34.285"
    },
    "district": "Центральный",
    "name": "Вязьма",
    "population": 52434,
    "subject": "Смоленская область"
    },
    {
    "coords": {
    "lat": "56.218417",
    "lon": "51.068583"
    },
    "district": "Приволжский",
    "name": "Вятские Поляны",
    "population": 31488,
    "subject": "Кировская область"
    },
    {
    "coords": {
    "lat": "56.56667",
    "lon": "40.11667"
    },
    "district": "Центральный",
    "name": "Гаврилов Посад",
    "population": 5492,
    "subject": "Ивановская область"
    },
    {
    "coords": {
    "lat": "57.3",
    "lon": "39.85"
    },
    "district": "Центральный",
    "name": "Гаврилов-Ям",
    "population": 16341,
    "subject": "Ярославская область"
    },
    {
    "coords": {
    "lat": "55.55",
    "lon": "35"
    },
    "district": "Центральный",
    "name": "Гагарин",
    "population": 28702,
    "subject": "Смоленская область"
    },
    {
    "coords": {
    "lat": "69.25528",
    "lon": "33.31667"
    },
    "district": "Северо-Западный",
    "name": "Гаджиево",
    "population": 13016,
    "subject": "Мурманская область"
    },
    {
    "coords": {
    "lat": "51.46667",
    "lon": "58.45"
    },
    "district": "Приволжский",
    "name": "Гай",
    "population": 33564,
    "subject": "Оренбургская область"
    },
    {
    "coords": {
    "lat": "58.38333",
    "lon": "42.35"
    },
    "district": "Центральный",
    "name": "Галич",
    "population": 16629,
    "subject": "Костромская область"
    },
    {
    "coords": {
    "lat": "59.56841",
    "lon": "30.122892"
    },
    "district": "Северо-Западный",
    "name": "Гатчина",
    "population": 89311,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "54.65",
    "lon": "21.06667"
    },
    "district": "Северо-Западный",
    "name": "Гвардейск",
    "population": 13353,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "58.73333",
    "lon": "27.81667"
    },
    "district": "Северо-Западный",
    "name": "Гдов",
    "population": 3216,
    "subject": "Псковская область"
    },
    {
    "coords": {
    "lat": "44.560999",
    "lon": "38.076949"
    },
    "district": "Южный",
    "name": "Геленджик",
    "population": 75504,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "44.15",
    "lon": "43.46667"
    },
    "district": "Северо-Кавказский",
    "name": "Георгиевск",
    "population": 65633,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "58.14083",
    "lon": "52.67417"
    },
    "district": "Приволжский",
    "name": "Глазов",
    "population": 91921,
    "subject": "Удмуртия"
    },
    {
    "coords": {
    "lat": "55.61472",
    "lon": "36.98722"
    },
    "district": "Центральный",
    "name": "Голицыно",
    "population": 17264,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "56.13333",
    "lon": "43.06667"
    },
    "district": "Приволжский",
    "name": "Горбатов",
    "population": 1828,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "51.96",
    "lon": "85.96"
    },
    "district": "Сибирский",
    "name": "Горно-Алтайск",
    "population": 64504,
    "subject": "Алтай"
    },
    {
    "coords": {
    "lat": "58.38333",
    "lon": "58.31667"
    },
    "district": "Приволжский",
    "name": "Горнозаводск",
    "population": 11103,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "50.993028",
    "lon": "81.467934"
    },
    "district": "Сибирский",
    "name": "Горняк",
    "population": 12115,
    "subject": "Алтайский край"
    },
    {
    "coords": {
    "lat": "56.65028",
    "lon": "43.47028"
    },
    "district": "Приволжский",
    "name": "Городец",
    "population": 29353,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "53.26667",
    "lon": "45.7"
    },
    "district": "Приволжский",
    "name": "Городище",
    "population": 7572,
    "subject": "Пензенская область"
    },
    {
    "coords": {
    "lat": "46.08333",
    "lon": "41.93333"
    },
    "district": "Южный",
    "name": "Городовиковск",
    "population": 8397,
    "subject": "Калмыкия"
    },
    {
    "coords": {
    "lat": "56.20278",
    "lon": "42.6925"
    },
    "district": "Центральный",
    "name": "Гороховец",
    "population": 12617,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "44.633284",
    "lon": "39.133287"
    },
    "district": "Южный",
    "name": "Горячий Ключ",
    "population": 41604,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "50.48333",
    "lon": "35.66667"
    },
    "district": "Центральный",
    "name": "Грайворон",
    "population": 6450,
    "subject": "Белгородская область"
    },
    {
    "coords": {
    "lat": "58.56667",
    "lon": "57.83333"
    },
    "district": "Приволжский",
    "name": "Гремячинск",
    "population": 7971,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "43.31667",
    "lon": "45.7"
    },
    "district": "Северо-Кавказский",
    "name": "Грозный",
    "population": 324602,
    "subject": "Чечня"
    },
    {
    "coords": {
    "lat": "52.5",
    "lon": "39.93333"
    },
    "district": "Центральный",
    "name": "Грязи",
    "population": 46415,
    "subject": "Липецкая область"
    },
    {
    "coords": {
    "lat": "58.88333",
    "lon": "40.25"
    },
    "district": "Северо-Западный",
    "name": "Грязовец",
    "population": 14797,
    "subject": "Вологодская область"
    },
    {
    "coords": {
    "lat": "58.86667",
    "lon": "57.58333"
    },
    "district": "Приволжский",
    "name": "Губаха",
    "population": 18825,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "51.28333",
    "lon": "37.55"
    },
    "district": "Центральный",
    "name": "Губкин",
    "population": 86073,
    "subject": "Белгородская область"
    },
    {
    "coords": {
    "lat": "64.43333",
    "lon": "76.5"
    },
    "district": "Уральский",
    "name": "Губкинский",
    "population": 28106,
    "subject": "Ямало-Ненецкий АО"
    },
    {
    "coords": {
    "lat": "43.34861",
    "lon": "46.09611"
    },
    "district": "Северо-Кавказский",
    "name": "Гудермес",
    "population": 57179,
    "subject": "Чечня"
    },
    {
    "coords": {
    "lat": "48.05",
    "lon": "39.93333"
    },
    "district": "Южный",
    "name": "Гуково",
    "population": 62658,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "45.36028",
    "lon": "40.69444"
    },
    "district": "Южный",
    "name": "Гулькевичи",
    "population": 34314,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "54.76667",
    "lon": "20.6"
    },
    "district": "Северо-Западный",
    "name": "Гурьевск",
    "population": 19670,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "54.28333",
    "lon": "85.93333"
    },
    "district": "Сибирский",
    "name": "Гурьевск",
    "population": 22134,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "54.58333",
    "lon": "22.2"
    },
    "district": "Северо-Западный",
    "name": "Гусев",
    "population": 28177,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "51.28556",
    "lon": "106.52917"
    },
    "district": "Сибирский",
    "name": "Гусиноозёрск",
    "population": 23263,
    "subject": "Бурятия"
    },
    {
    "coords": {
    "lat": "55.61667",
    "lon": "40.65"
    },
    "district": "Центральный",
    "name": "Гусь-Хрустальный",
    "population": 51998,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "54.21667",
    "lon": "55.03333"
    },
    "district": "Приволжский",
    "name": "Давлеканово",
    "population": 22971,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "42.11667",
    "lon": "48.2"
    },
    "district": "Северо-Кавказский",
    "name": "Дагестанские Огни",
    "population": 30120,
    "subject": "Дагестан"
    },
    {
    "coords": {
    "lat": "56.26667",
    "lon": "62.91667"
    },
    "district": "Уральский",
    "name": "Далматово",
    "population": 11938,
    "subject": "Курганская область"
    },
    {
    "coords": {
    "lat": "44.56667",
    "lon": "135.61667"
    },
    "district": "Дальневосточный",
    "name": "Дальнегорск",
    "population": 33803,
    "subject": "Приморский край"
    },
    {
    "coords": {
    "lat": "45.93333",
    "lon": "133.73333"
    },
    "district": "Дальневосточный",
    "name": "Дальнереченск",
    "population": 24786,
    "subject": "Приморский край"
    },
    {
    "coords": {
    "lat": "58.18333",
    "lon": "40.18333"
    },
    "district": "Центральный",
    "name": "Данилов",
    "population": 14416,
    "subject": "Ярославская область"
    },
    {
    "coords": {
    "lat": "53.25",
    "lon": "39.15"
    },
    "district": "Центральный",
    "name": "Данков",
    "population": 18558,
    "subject": "Липецкая область"
    },
    {
    "coords": {
    "lat": "56.7",
    "lon": "60.1"
    },
    "district": "Уральский",
    "name": "Дегтярск",
    "population": 15326,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "55.86667",
    "lon": "37.13333"
    },
    "district": "Центральный",
    "name": "Дедовск",
    "population": 30645,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "55.26667",
    "lon": "31.51667"
    },
    "district": "Центральный",
    "name": "Демидов",
    "population": 6033,
    "subject": "Смоленская область"
    },
    {
    "coords": {
    "lat": "42.069825",
    "lon": "48.295025"
    },
    "district": "Северо-Кавказский",
    "name": "Дербент",
    "population": 126606,
    "subject": "Дагестан"
    },
    {
    "coords": {
    "lat": "54.1530861",
    "lon": "33.2902917"
    },
    "district": "Центральный",
    "name": "Десногорск",
    "population": 27051,
    "subject": "Смоленская область"
    },
    {
    "coords": {
    "lat": "45.70861",
    "lon": "34.39333"
    },
    "district": "Южный",
    "name": "Джанкой",
    "population": 37410,
    "subject": "Крым"
    },
    {
    "coords": {
    "lat": "56.23333",
    "lon": "43.45"
    },
    "district": "Приволжский",
    "name": "Дзержинск",
    "population": 227326,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "55.63333",
    "lon": "37.85"
    },
    "district": "Центральный",
    "name": "Дзержинский",
    "population": 52797,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "55.95",
    "lon": "92.38333"
    },
    "district": "Сибирский",
    "name": "Дивногорск",
    "population": 29072,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "43.15",
    "lon": "44.15"
    },
    "district": "Северо-Кавказский",
    "name": "Дигора",
    "population": 10166,
    "subject": "Северная Осетия"
    },
    {
    "coords": {
    "lat": "54.23333",
    "lon": "49.58333"
    },
    "district": "Приволжский",
    "name": "Димитровград",
    "population": 112388,
    "subject": "Ульяновская область"
    },
    {
    "coords": {
    "lat": "52.12889",
    "lon": "35.07556"
    },
    "district": "Центральный",
    "name": "Дмитриев",
    "population": 6244,
    "subject": "Курская область"
    },
    {
    "coords": {
    "lat": "56.34667",
    "lon": "37.52167"
    },
    "district": "Центральный",
    "name": "Дмитров",
    "population": 68397,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "52.505504",
    "lon": "35.141478"
    },
    "district": "Центральный",
    "name": "Дмитровск",
    "population": 4947,
    "subject": "Орловская область"
    },
    {
    "coords": {
    "lat": "57.83333",
    "lon": "29.96667"
    },
    "district": "Северо-Западный",
    "name": "Дно",
    "population": 7267,
    "subject": "Псковская область"
    },
    {
    "coords": {
    "lat": "58.45",
    "lon": "56.41667"
    },
    "district": "Приволжский",
    "name": "Добрянка",
    "population": 31825,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "55.93333",
    "lon": "37.5"
    },
    "district": "Центральный",
    "name": "Долгопрудный",
    "population": 117778,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "47.31667",
    "lon": "142.8"
    },
    "district": "Дальневосточный",
    "name": "Долинск",
    "population": 11774,
    "subject": "Сахалинская область"
    },
    {
    "coords": {
    "lat": "55.44389",
    "lon": "37.75806"
    },
    "district": "Центральный",
    "name": "Домодедово",
    "population": 135070,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "48.33694",
    "lon": "39.945"
    },
    "district": "Южный",
    "name": "Донецк",
    "population": 46741,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "53.96667",
    "lon": "38.31667"
    },
    "district": "Центральный",
    "name": "Донской",
    "population": 61477,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "54.92",
    "lon": "33.30778"
    },
    "district": "Центральный",
    "name": "Дорогобуж",
    "population": 9202,
    "subject": "Смоленская область"
    },
    {
    "coords": {
    "lat": "55.74444",
    "lon": "38.84944"
    },
    "district": "Центральный",
    "name": "Дрезна",
    "population": 11294,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "56.75",
    "lon": "37.15"
    },
    "district": "Центральный",
    "name": "Дубна",
    "population": 74499,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "49.05",
    "lon": "44.83333"
    },
    "district": "Южный",
    "name": "Дубовка",
    "population": 13442,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "69.4",
    "lon": "86.18333"
    },
    "district": "Сибирский",
    "name": "Дудинка",
    "population": 20908,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "55.2",
    "lon": "32.41667"
    },
    "district": "Центральный",
    "name": "Духовщина",
    "population": 3832,
    "subject": "Смоленская область"
    },
    {
    "coords": {
    "lat": "55.48333",
    "lon": "54.86667"
    },
    "district": "Приволжский",
    "name": "Дюртюли",
    "population": 31217,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "53.6",
    "lon": "34.33333"
    },
    "district": "Центральный",
    "name": "Дятьково",
    "population": 25839,
    "subject": "Брянская область"
    },
    {
    "coords": {
    "lat": "45.2",
    "lon": "33.35833"
    },
    "district": "Южный",
    "name": "Евпатория",
    "population": 108149,
    "subject": "Крым"
    },
    {
    "coords": {
    "lat": "55.38333",
    "lon": "39.03361"
    },
    "district": "Центральный",
    "name": "Егорьевск",
    "population": 73046,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "46.71056",
    "lon": "38.27778"
    },
    "district": "Южный",
    "name": "Ейск",
    "population": 83127,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "56.83333",
    "lon": "60.58333"
    },
    "district": "Уральский",
    "name": "Екатеринбург",
    "population": 1495066,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "55.76667",
    "lon": "52.03333"
    },
    "district": "Приволжский",
    "name": "Елабуга",
    "population": 73866,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "52.61667",
    "lon": "38.46667"
    },
    "district": "Центральный",
    "name": "Елец",
    "population": 101306,
    "subject": "Липецкая область"
    },
    {
    "coords": {
    "lat": "53.18333",
    "lon": "158.38333"
    },
    "district": "Дальневосточный",
    "name": "Елизово",
    "population": 38893,
    "subject": "Камчатский край"
    },
    {
    "coords": {
    "lat": "54.56667",
    "lon": "33.16667"
    },
    "district": "Центральный",
    "name": "Ельня",
    "population": 8629,
    "subject": "Смоленская область"
    },
    {
    "coords": {
    "lat": "54.75",
    "lon": "61.31667"
    },
    "district": "Уральский",
    "name": "Еманжелинск",
    "population": 27880,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "62.58333",
    "lon": "50.85"
    },
    "district": "Северо-Западный",
    "name": "Емва",
    "population": 12378,
    "subject": "Коми"
    },
    {
    "coords": {
    "lat": "58.46667",
    "lon": "92.13333"
    },
    "district": "Сибирский",
    "name": "Енисейск",
    "population": 17882,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "55.20556",
    "lon": "36.57"
    },
    "district": "Центральный",
    "name": "Ермолино",
    "population": 10157,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "51.35",
    "lon": "48.28333"
    },
    "district": "Приволжский",
    "name": "Ершов",
    "population": 18431,
    "subject": "Саратовская область"
    },
    {
    "coords": {
    "lat": "44.04306",
    "lon": "42.86417"
    },
    "district": "Северо-Кавказский",
    "name": "Ессентуки",
    "population": 114824,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "53.149167",
    "lon": "38.082585"
    },
    "district": "Центральный",
    "name": "Ефремов",
    "population": 33965,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "44.13333",
    "lon": "43.03333"
    },
    "district": "Северо-Кавказский",
    "name": "Железноводск",
    "population": 24869,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "56.58333",
    "lon": "104.11667"
    },
    "district": "Сибирский",
    "name": "Железногорск-Илимский",
    "population": 22743,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "56.25",
    "lon": "93.53333"
    },
    "district": "Сибирский",
    "name": "Железногорск",
    "population": 81619,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "52.339174",
    "lon": "35.351582"
    },
    "district": "Центральный",
    "name": "Железногорск",
    "population": 100554,
    "subject": "Курская область"
    },
    {
    "coords": {
    "lat": "51.83333",
    "lon": "41.46667"
    },
    "district": "Центральный",
    "name": "Жердевка",
    "population": 13825,
    "subject": "Тамбовская область"
    },
    {
    "coords": {
    "lat": "53.4",
    "lon": "49.5"
    },
    "district": "Приволжский",
    "name": "Жигулёвск",
    "population": 50782,
    "subject": "Самарская область"
    },
    {
    "coords": {
    "lat": "53.75028",
    "lon": "34.73611"
    },
    "district": "Центральный",
    "name": "Жиздра",
    "population": 5317,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "50.98028",
    "lon": "44.78083"
    },
    "district": "Южный",
    "name": "Жирновск",
    "population": 15259,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "55.03333",
    "lon": "36.75"
    },
    "district": "Центральный",
    "name": "Жуков",
    "population": 13828,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "53.53333",
    "lon": "33.73333"
    },
    "district": "Центральный",
    "name": "Жуковка",
    "population": 16288,
    "subject": "Брянская область"
    },
    {
    "coords": {
    "lat": "55.60111",
    "lon": "38.11611"
    },
    "district": "Центральный",
    "name": "Жуковский",
    "population": 107558,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "50.11667",
    "lon": "129.43333"
    },
    "district": "Дальневосточный",
    "name": "Завитинск",
    "population": 9957,
    "subject": "Амурская область"
    },
    {
    "coords": {
    "lat": "56.5",
    "lon": "66.55"
    },
    "district": "Уральский",
    "name": "Заводоуковск",
    "population": 26477,
    "subject": "Тюменская область"
    },
    {
    "coords": {
    "lat": "57.48333",
    "lon": "42.13333"
    },
    "district": "Центральный",
    "name": "Заволжск",
    "population": 9484,
    "subject": "Ивановская область"
    },
    {
    "coords": {
    "lat": "56.6425",
    "lon": "43.39278"
    },
    "district": "Приволжский",
    "name": "Заволжье",
    "population": 37248,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "52.38333",
    "lon": "38.91667"
    },
    "district": "Центральный",
    "name": "Задонск",
    "population": 9447,
    "subject": "Липецкая область"
    },
    {
    "coords": {
    "lat": "55.3",
    "lon": "52.01667"
    },
    "district": "Приволжский",
    "name": "Заинск",
    "population": 39068,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "50.38333",
    "lon": "103.28333"
    },
    "district": "Сибирский",
    "name": "Закаменск",
    "population": 11191,
    "subject": "Бурятия"
    },
    {
    "coords": {
    "lat": "55.96667",
    "lon": "94.7"
    },
    "district": "Сибирский",
    "name": "Заозёрный",
    "population": 9954,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "69.4",
    "lon": "32.45"
    },
    "district": "Северо-Западный",
    "name": "Заозёрск",
    "population": 9120,
    "subject": "Мурманская область"
    },
    {
    "coords": {
    "lat": "56.26667",
    "lon": "32.08333"
    },
    "district": "Центральный",
    "name": "Западная Двина",
    "population": 7608,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "69.41667",
    "lon": "30.8"
    },
    "district": "Северо-Западный",
    "name": "Заполярный",
    "population": 14330,
    "subject": "Мурманская область"
    },
    {
    "coords": {
    "lat": "54.76528",
    "lon": "38.88361"
    },
    "district": "Центральный",
    "name": "Зарайск",
    "population": 22581,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "53.2",
    "lon": "45.16667"
    },
    "district": "Приволжский",
    "name": "Заречный",
    "population": 65493,
    "subject": "Пензенская область"
    },
    {
    "coords": {
    "lat": "56.81667",
    "lon": "61.31667"
    },
    "district": "Уральский",
    "name": "Заречный",
    "population": 28171,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "53.7",
    "lon": "84.91667"
    },
    "district": "Сибирский",
    "name": "Заринск",
    "population": 45405,
    "subject": "Алтайский край"
    },
    {
    "coords": {
    "lat": "55.96667",
    "lon": "48.01667"
    },
    "district": "Приволжский",
    "name": "Звенигово",
    "population": 10966,
    "subject": "Марий Эл"
    },
    {
    "coords": {
    "lat": "55.73333",
    "lon": "36.85"
    },
    "district": "Центральный",
    "name": "Звенигород",
    "population": 23649,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "48.01667",
    "lon": "40.11667"
    },
    "district": "Южный",
    "name": "Зверево",
    "population": 17638,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "56.1",
    "lon": "94.58333"
    },
    "district": "Сибирский",
    "name": "Зеленогорск",
    "population": 61821,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "60.2",
    "lon": "29.7"
    },
    "district": "Северо-Западный",
    "name": "Зеленогорск",
    "population": 15208,
    "subject": "Санкт-Петербург"
    },
    {
    "coords": {
    "lat": "55.997917",
    "lon": "37.190417"
    },
    "district": "Центральный",
    "name": "Зеленоград",
    "population": 250173,
    "subject": "Москва"
    },
    {
    "coords": {
    "lat": "54.95",
    "lon": "20.48333"
    },
    "district": "Северо-Западный",
    "name": "Зеленоградск",
    "population": 17296,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "55.85",
    "lon": "48.51667"
    },
    "district": "Приволжский",
    "name": "Зеленодольск",
    "population": 100009,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "44.4070115",
    "lon": "43.8731235"
    },
    "district": "Северо-Кавказский",
    "name": "Зеленокумск",
    "population": 33738,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "46.846525",
    "lon": "40.3040333"
    },
    "district": "Южный",
    "name": "Зерноград",
    "population": 23847,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "53.73333",
    "lon": "127.25"
    },
    "district": "Дальневосточный",
    "name": "Зея",
    "population": 22714,
    "subject": "Амурская область"
    },
    {
    "coords": {
    "lat": "53.91667",
    "lon": "102.05"
    },
    "district": "Сибирский",
    "name": "Зима",
    "population": 30337,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "55.16667",
    "lon": "59.66667"
    },
    "district": "Уральский",
    "name": "Златоуст",
    "population": 162148,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "52.43333",
    "lon": "31.73333"
    },
    "district": "Центральный",
    "name": "Злынка",
    "population": 5323,
    "subject": "Брянская область"
    },
    {
    "coords": {
    "lat": "51.16667",
    "lon": "82.16667"
    },
    "district": "Сибирский",
    "name": "Змеиногорск",
    "population": 10187,
    "subject": "Алтайский край"
    },
    {
    "coords": {
    "lat": "48.58333",
    "lon": "45.75"
    },
    "district": "Южный",
    "name": "Знаменск",
    "population": 26361,
    "subject": "Астраханская область"
    },
    {
    "coords": {
    "lat": "56.16667",
    "lon": "34.58333"
    },
    "district": "Центральный",
    "name": "Зубцов",
    "population": 6084,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "58.403333",
    "lon": "51.130361"
    },
    "district": "Приволжский",
    "name": "Зуевка",
    "population": 9983,
    "subject": "Кировская область"
    },
    {
    "coords": {
    "lat": "59.37649",
    "lon": "28.219712"
    },
    "district": "Северо-Западный",
    "name": "Ивангород",
    "population": 9320,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "56.99667",
    "lon": "40.98194"
    },
    "district": "Центральный",
    "name": "Иваново",
    "population": 401505,
    "subject": "Ивановская область"
    },
    {
    "coords": {
    "lat": "55.97",
    "lon": "37.92"
    },
    "district": "Центральный",
    "name": "Ивантеевка",
    "population": 82779,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "60.68333",
    "lon": "60.43333"
    },
    "district": "Уральский",
    "name": "Ивдель",
    "population": 15244,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "67.46667",
    "lon": "86.56667"
    },
    "district": "Сибирский",
    "name": "Игарка",
    "population": 4274,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "56.85306",
    "lon": "53.21222"
    },
    "district": "Приволжский",
    "name": "Ижевск",
    "population": 646468,
    "subject": "Удмуртия"
    },
    {
    "coords": {
    "lat": "42.56667",
    "lon": "47.86667"
    },
    "district": "Северо-Кавказский",
    "name": "Избербаш",
    "population": 61296,
    "subject": "Дагестан"
    },
    {
    "coords": {
    "lat": "45.36667",
    "lon": "41.71667"
    },
    "district": "Северо-Кавказский",
    "name": "Изобильный",
    "population": 37366,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "56.23333",
    "lon": "96.06667"
    },
    "district": "Сибирский",
    "name": "Иланский",
    "population": 14768,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "53.85",
    "lon": "46.35"
    },
    "district": "Приволжский",
    "name": "Инза",
    "population": 17016,
    "subject": "Ульяновская область"
    },
    {
    "coords": {
    "lat": "44.61417",
    "lon": "33.60833"
    },
    "district": "Южный",
    "name": "Инкерман",
    "population": 10027,
    "subject": "Севастополь"
    },
    {
    "coords": {
    "lat": "55.763633",
    "lon": "48.736553"
    },
    "district": "Приволжский",
    "name": "Иннополис",
    "population": 866,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "53.86667",
    "lon": "44.36667"
    },
    "district": "Приволжский",
    "name": "Инсар",
    "population": 7501,
    "subject": "Мордовия"
    },
    {
    "coords": {
    "lat": "66.0398139",
    "lon": "60.1315194"
    },
    "district": "Северо-Западный",
    "name": "Инта",
    "population": 23701,
    "subject": "Коми"
    },
    {
    "coords": {
    "lat": "45.71667",
    "lon": "42.9"
    },
    "district": "Северо-Кавказский",
    "name": "Ипатово",
    "population": 22816,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "57.66667",
    "lon": "63.06667"
    },
    "district": "Уральский",
    "name": "Ирбит",
    "population": 36128,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "52.28333",
    "lon": "104.3"
    },
    "district": "Сибирский",
    "name": "Иркутск",
    "population": 617515,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "54.90889",
    "lon": "71.26056"
    },
    "district": "Сибирский",
    "name": "Исилькуль",
    "population": 22101,
    "subject": "Омская область"
    },
    {
    "coords": {
    "lat": "54.63333",
    "lon": "83.3"
    },
    "district": "Сибирский",
    "name": "Искитим",
    "population": 55433,
    "subject": "Новосибирская область"
    },
    {
    "coords": {
    "lat": "55.91667",
    "lon": "36.86667"
    },
    "district": "Центральный",
    "name": "Истра",
    "population": 33332,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "56.11667",
    "lon": "69.5"
    },
    "district": "Уральский",
    "name": "Ишим",
    "population": 64010,
    "subject": "Тюменская область"
    },
    {
    "coords": {
    "lat": "53.45444",
    "lon": "56.04389"
    },
    "district": "Приволжский",
    "name": "Ишимбай",
    "population": 63849,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "56.63278",
    "lon": "47.89583"
    },
    "district": "Приволжский",
    "name": "Йошкар-Ола",
    "population": 276155,
    "subject": "Марий Эл"
    },
    {
    "coords": {
    "lat": "59.5",
    "lon": "40.33333"
    },
    "district": "Северо-Западный",
    "name": "Кадников",
    "population": 4440,
    "subject": "Вологодская область"
    },
    {
    "coords": {
    "lat": "55.79083",
    "lon": "49.11444"
    },
    "district": "Приволжский",
    "name": "Казань",
    "population": 1257341,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "48.68333",
    "lon": "43.53333"
    },
    "district": "Южный",
    "name": "Калач-на-Дону",
    "population": 23503,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "50.42583",
    "lon": "41.01556"
    },
    "district": "Центральный",
    "name": "Калач",
    "population": 17896,
    "subject": "Воронежская область"
    },
    {
    "coords": {
    "lat": "55.05",
    "lon": "74.58333"
    },
    "district": "Сибирский",
    "name": "Калачинск",
    "population": 22297,
    "subject": "Омская область"
    },
    {
    "coords": {
    "lat": "54.71667",
    "lon": "20.5"
    },
    "district": "Северо-Западный",
    "name": "Калининград",
    "population": 493256,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "51.5",
    "lon": "44.45"
    },
    "district": "Приволжский",
    "name": "Калининск",
    "population": 15207,
    "subject": "Саратовская область"
    },
    {
    "coords": {
    "lat": "53.51667",
    "lon": "87.26667"
    },
    "district": "Сибирский",
    "name": "Калтан",
    "population": 20193,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "54.53333",
    "lon": "36.26667"
    },
    "district": "Центральный",
    "name": "Калуга",
    "population": 331842,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "57.23333",
    "lon": "37.85"
    },
    "district": "Центральный",
    "name": "Калязин",
    "population": 12294,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "56.26667",
    "lon": "54.2"
    },
    "district": "Приволжский",
    "name": "Камбарка",
    "population": 10048,
    "subject": "Удмуртия"
    },
    {
    "coords": {
    "lat": "53.18333",
    "lon": "44.05"
    },
    "district": "Приволжский",
    "name": "Каменка",
    "population": 33933,
    "subject": "Пензенская область"
    },
    {
    "coords": {
    "lat": "60.95081",
    "lon": "29.130882"
    },
    "district": "Северо-Западный",
    "name": "Каменногорск",
    "population": 6151,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "56.4",
    "lon": "61.93333"
    },
    "district": "Уральский",
    "name": "Каменск-Уральский",
    "population": 163990,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "48.31667",
    "lon": "40.26667"
    },
    "district": "Южный",
    "name": "Каменск-Шахтинский",
    "population": 87113,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "53.79194",
    "lon": "81.34861"
    },
    "district": "Сибирский",
    "name": "Камень-на-Оби",
    "population": 40294,
    "subject": "Алтайский край"
    },
    {
    "coords": {
    "lat": "56.34917",
    "lon": "40.99778"
    },
    "district": "Центральный",
    "name": "Камешково",
    "population": 11840,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "46.11556",
    "lon": "48.07694"
    },
    "district": "Южный",
    "name": "Камызяк",
    "population": 15753,
    "subject": "Астраханская область"
    },
    {
    "coords": {
    "lat": "50.08333",
    "lon": "45.4"
    },
    "district": "Южный",
    "name": "Камышин",
    "population": 108665,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "56.85",
    "lon": "62.71667"
    },
    "district": "Уральский",
    "name": "Камышлов",
    "population": 25582,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "55.50694",
    "lon": "47.49139"
    },
    "district": "Приволжский",
    "name": "Канаш",
    "population": 44438,
    "subject": "Чувашия"
    },
    {
    "coords": {
    "lat": "67.15694",
    "lon": "32.41167"
    },
    "district": "Северо-Западный",
    "name": "Кандалакша",
    "population": 29750,
    "subject": "Мурманская область"
    },
    {
    "coords": {
    "lat": "56.2",
    "lon": "95.7"
    },
    "district": "Сибирский",
    "name": "Канск",
    "population": 88362,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "56.30889",
    "lon": "38.70139"
    },
    "district": "Центральный",
    "name": "Карабаново",
    "population": 15023,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "55.48333",
    "lon": "60.2"
    },
    "district": "Уральский",
    "name": "Карабаш",
    "population": 10616,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "43.306285",
    "lon": "44.909763"
    },
    "district": "Северо-Кавказский",
    "name": "Карабулак",
    "population": 43549,
    "subject": "Ингушетия"
    },
    {
    "coords": {
    "lat": "53.73333",
    "lon": "78.03333"
    },
    "district": "Сибирский",
    "name": "Карасук",
    "population": 26733,
    "subject": "Новосибирская область"
    },
    {
    "coords": {
    "lat": "43.769713",
    "lon": "41.911369"
    },
    "district": "Северо-Кавказский",
    "name": "Карачаевск",
    "population": 20711,
    "subject": "Карачаево-Черкесия"
    },
    {
    "coords": {
    "lat": "53.11667",
    "lon": "34.98333"
    },
    "district": "Центральный",
    "name": "Карачев",
    "population": 16921,
    "subject": "Брянская область"
    },
    {
    "coords": {
    "lat": "55.2",
    "lon": "80.28333"
    },
    "district": "Сибирский",
    "name": "Каргат",
    "population": 8914,
    "subject": "Новосибирская область"
    },
    {
    "coords": {
    "lat": "61.5",
    "lon": "38.93333"
    },
    "district": "Северо-Западный",
    "name": "Каргополь",
    "population": 10025,
    "subject": "Архангельская область"
    },
    {
    "coords": {
    "lat": "59.76667",
    "lon": "60"
    },
    "district": "Уральский",
    "name": "Карпинск",
    "population": 25599,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "53.05",
    "lon": "60.65"
    },
    "district": "Уральский",
    "name": "Карталы",
    "population": 28029,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "54.95",
    "lon": "41.39722"
    },
    "district": "Центральный",
    "name": "Касимов",
    "population": 28753,
    "subject": "Рязанская область"
    },
    {
    "coords": {
    "lat": "55.88333",
    "lon": "60.75"
    },
    "district": "Уральский",
    "name": "Касли",
    "population": 15417,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "42.88333",
    "lon": "47.63333"
    },
    "district": "Северо-Кавказский",
    "name": "Каспийск",
    "population": 128663,
    "subject": "Дагестан"
    },
    {
    "coords": {
    "lat": "54.75",
    "lon": "58.2"
    },
    "district": "Уральский",
    "name": "Катав-Ивановск",
    "population": 15368,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "56.3",
    "lon": "62.56667"
    },
    "district": "Уральский",
    "name": "Катайск",
    "population": 12341,
    "subject": "Курганская область"
    },
    {
    "coords": {
    "lat": "58.7",
    "lon": "59.48333"
    },
    "district": "Уральский",
    "name": "Качканар",
    "population": 37687,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "57.35",
    "lon": "37.61667"
    },
    "district": "Центральный",
    "name": "Кашин",
    "population": 13576,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "54.83333",
    "lon": "38.15"
    },
    "district": "Центральный",
    "name": "Кашира",
    "population": 46380,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "57.56667",
    "lon": "79.56667"
    },
    "district": "Сибирский",
    "name": "Кедровый",
    "population": 1918,
    "subject": "Томская область"
    },
    {
    "coords": {
    "lat": "55.35417",
    "lon": "86.08972"
    },
    "district": "Сибирский",
    "name": "Кемерово",
    "population": 552546,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "64.95",
    "lon": "34.6"
    },
    "district": "Северо-Западный",
    "name": "Кемь",
    "population": 10463,
    "subject": "Карелия"
    },
    {
    "coords": {
    "lat": "45.33861",
    "lon": "36.46806"
    },
    "district": "Южный",
    "name": "Керчь",
    "population": 151996,
    "subject": "Крым"
    },
    {
    "coords": {
    "lat": "59.05",
    "lon": "57.65"
    },
    "district": "Приволжский",
    "name": "Кизел",
    "population": 13186,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "43.2",
    "lon": "46.86667"
    },
    "district": "Северо-Кавказский",
    "name": "Кизилюрт",
    "population": 38147,
    "subject": "Дагестан"
    },
    {
    "coords": {
    "lat": "43.85",
    "lon": "46.71667"
    },
    "district": "Северо-Кавказский",
    "name": "Кизляр",
    "population": 49181,
    "subject": "Дагестан"
    },
    {
    "coords": {
    "lat": "53.96667",
    "lon": "38.53333"
    },
    "district": "Центральный",
    "name": "Кимовск",
    "population": 25142,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "56.86667",
    "lon": "37.35"
    },
    "district": "Центральный",
    "name": "Кимры",
    "population": 42301,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "59.378053",
    "lon": "28.601209"
    },
    "district": "Северо-Западный",
    "name": "Кингисепп",
    "population": 44612,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "53.23333",
    "lon": "50.61667"
    },
    "district": "Приволжский",
    "name": "Кинель",
    "population": 35644,
    "subject": "Самарская область"
    },
    {
    "coords": {
    "lat": "57.45",
    "lon": "42.15"
    },
    "district": "Центральный",
    "name": "Кинешма",
    "population": 79936,
    "subject": "Ивановская область"
    },
    {
    "coords": {
    "lat": "53.93333",
    "lon": "37.93333"
    },
    "district": "Центральный",
    "name": "Киреевск",
    "population": 26277,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "57.78333",
    "lon": "108.1"
    },
    "district": "Сибирский",
    "name": "Киренск",
    "population": 10989,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "56.15",
    "lon": "38.86667"
    },
    "district": "Центральный",
    "name": "Киржач",
    "population": 26381,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "59.86667",
    "lon": "38.38333"
    },
    "district": "Северо-Западный",
    "name": "Кириллов",
    "population": 7371,
    "subject": "Вологодская область"
    },
    {
    "coords": {
    "lat": "59.449695",
    "lon": "32.008716"
    },
    "district": "Северо-Западный",
    "name": "Кириши",
    "population": 50079,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "54.08333",
    "lon": "34.3"
    },
    "district": "Центральный",
    "name": "Киров",
    "population": 29925,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "58.6",
    "lon": "49.65"
    },
    "district": "Приволжский",
    "name": "Киров",
    "population": 521091,
    "subject": "Кировская область"
    },
    {
    "coords": {
    "lat": "57.43333",
    "lon": "60.06667"
    },
    "district": "Уральский",
    "name": "Кировград",
    "population": 18577,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "58.55",
    "lon": "50.01667"
    },
    "district": "Приволжский",
    "name": "Кирово-Чепецк",
    "population": 68588,
    "subject": "Кировская область"
    },
    {
    "coords": {
    "lat": "59.87533",
    "lon": "30.981457"
    },
    "district": "Северо-Западный",
    "name": "Кировск",
    "population": 27391,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "67.61417",
    "lon": "33.67167"
    },
    "district": "Северо-Западный",
    "name": "Кировск",
    "population": 25944,
    "subject": "Мурманская область"
    },
    {
    "coords": {
    "lat": "59.337167",
    "lon": "52.245472"
    },
    "district": "Приволжский",
    "name": "Кирс",
    "population": 8982,
    "subject": "Кировская область"
    },
    {
    "coords": {
    "lat": "52.65",
    "lon": "42.73333"
    },
    "district": "Центральный",
    "name": "Кирсанов",
    "population": 15753,
    "subject": "Тамбовская область"
    },
    {
    "coords": {
    "lat": "53.98333",
    "lon": "86.7"
    },
    "district": "Сибирский",
    "name": "Киселёвск",
    "population": 85339,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "43.90333",
    "lon": "42.72444"
    },
    "district": "Северо-Кавказский",
    "name": "Кисловодск",
    "population": 127919,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "56.33389",
    "lon": "36.7125"
    },
    "district": "Центральный",
    "name": "Клин",
    "population": 79635,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "52.75278",
    "lon": "32.23611"
    },
    "district": "Центральный",
    "name": "Клинцы",
    "population": 62704,
    "subject": "Брянская область"
    },
    {
    "coords": {
    "lat": "55.81667",
    "lon": "45.03333"
    },
    "district": "Приволжский",
    "name": "Княгинино",
    "population": 6563,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "67.55944",
    "lon": "30.46667"
    },
    "district": "Северо-Западный",
    "name": "Ковдор",
    "population": 15850,
    "subject": "Мурманская область"
    },
    {
    "coords": {
    "lat": "56.36056",
    "lon": "41.31972"
    },
    "district": "Центральный",
    "name": "Ковров",
    "population": 134074,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "54.03333",
    "lon": "43.91667"
    },
    "district": "Приволжский",
    "name": "Ковылкино",
    "population": 18585,
    "subject": "Мордовия"
    },
    {
    "coords": {
    "lat": "62.26667",
    "lon": "74.48333"
    },
    "district": "Уральский",
    "name": "Когалым",
    "population": 68700,
    "subject": "Ханты-Мансийский АО"
    },
    {
    "coords": {
    "lat": "58.6",
    "lon": "99.18333"
    },
    "district": "Сибирский",
    "name": "Кодинск",
    "population": 15436,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "54.03333",
    "lon": "35.78333"
    },
    "district": "Центральный",
    "name": "Козельск",
    "population": 16329,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "55.83333",
    "lon": "48.25"
    },
    "district": "Приволжский",
    "name": "Козловка",
    "population": 8450,
    "subject": "Чувашия"
    },
    {
    "coords": {
    "lat": "56.33333",
    "lon": "46.56667"
    },
    "district": "Приволжский",
    "name": "Козьмодемьянск",
    "population": 19970,
    "subject": "Марий Эл"
    },
    {
    "coords": {
    "lat": "68.88306",
    "lon": "33.02194"
    },
    "district": "Северо-Западный",
    "name": "Кола",
    "population": 9560,
    "subject": "Мурманская область"
    },
    {
    "coords": {
    "lat": "58.8252278",
    "lon": "44.311444"
    },
    "district": "Центральный",
    "name": "Кологрив",
    "population": 2706,
    "subject": "Костромская область"
    },
    {
    "coords": {
    "lat": "55.09389",
    "lon": "38.76806"
    },
    "district": "Центральный",
    "name": "Коломна",
    "population": 138693,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "58.31667",
    "lon": "82.91667"
    },
    "district": "Сибирский",
    "name": "Колпашево",
    "population": 22589,
    "subject": "Томская область"
    },
    {
    "coords": {
    "lat": "59.75",
    "lon": "30.6"
    },
    "district": "Северо-Западный",
    "name": "Колпино",
    "population": 149766,
    "subject": "Санкт-Петербург"
    },
    {
    "coords": {
    "lat": "56.3",
    "lon": "39.38333"
    },
    "district": "Центральный",
    "name": "Кольчугино",
    "population": 41369,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "59.621609",
    "lon": "30.393483"
    },
    "district": "Северо-Западный",
    "name": "Коммунар",
    "population": 21920,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "50.55",
    "lon": "137"
    },
    "district": "Дальневосточный",
    "name": "Комсомольск-на-Амуре",
    "population": 241072,
    "subject": "Хабаровский край"
    },
    {
    "coords": {
    "lat": "57.03333",
    "lon": "40.38333"
    },
    "district": "Центральный",
    "name": "Комсомольск",
    "population": 7978,
    "subject": "Ивановская область"
    },
    {
    "coords": {
    "lat": "56.7",
    "lon": "36.76667"
    },
    "district": "Центральный",
    "name": "Конаково",
    "population": 35407,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "62.2",
    "lon": "34.26667"
    },
    "district": "Северо-Западный",
    "name": "Кондопога",
    "population": 28744,
    "subject": "Карелия"
    },
    {
    "coords": {
    "lat": "54.8",
    "lon": "35.93333"
    },
    "district": "Центральный",
    "name": "Кондрово",
    "population": 14424,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "47.58333",
    "lon": "41.1"
    },
    "district": "Южный",
    "name": "Константиновск",
    "population": 16842,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "55.1",
    "lon": "61.61667"
    },
    "district": "Уральский",
    "name": "Копейск",
    "population": 145961,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "53.91667",
    "lon": "40.01667"
    },
    "district": "Центральный",
    "name": "Кораблино",
    "population": 10920,
    "subject": "Рязанская область"
    },
    {
    "coords": {
    "lat": "45.46667",
    "lon": "39.45"
    },
    "district": "Южный",
    "name": "Кореновск",
    "population": 42480,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "54.88333",
    "lon": "61.4"
    },
    "district": "Уральский",
    "name": "Коркино",
    "population": 33451,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "55.91667",
    "lon": "37.81667"
    },
    "district": "Центральный",
    "name": "Королёв",
    "population": 225299,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "50.81361",
    "lon": "37.18139"
    },
    "district": "Центральный",
    "name": "Короча",
    "population": 5659,
    "subject": "Белгородская область"
    },
    {
    "coords": {
    "lat": "46.63333",
    "lon": "142.76667"
    },
    "district": "Дальневосточный",
    "name": "Корсаков",
    "population": 33451,
    "subject": "Сахалинская область"
    },
    {
    "coords": {
    "lat": "61.3",
    "lon": "47.16667"
    },
    "district": "Северо-Западный",
    "name": "Коряжма",
    "population": 35345,
    "subject": "Архангельская область"
    },
    {
    "coords": {
    "lat": "55.93333",
    "lon": "39.63333"
    },
    "district": "Центральный",
    "name": "Костерёво",
    "population": 7997,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "64.58333",
    "lon": "30.6"
    },
    "district": "Северо-Западный",
    "name": "Костомукша",
    "population": 29778,
    "subject": "Карелия"
    },
    {
    "coords": {
    "lat": "57.76667",
    "lon": "40.93333"
    },
    "district": "Центральный",
    "name": "Кострома",
    "population": 277393,
    "subject": "Костромская область"
    },
    {
    "coords": {
    "lat": "55.6625",
    "lon": "37.86722"
    },
    "district": "Центральный",
    "name": "Котельники",
    "population": 50723,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "47.63333",
    "lon": "43.13333"
    },
    "district": "Южный",
    "name": "Котельниково",
    "population": 20317,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "58.3",
    "lon": "48.33333"
    },
    "district": "Приволжский",
    "name": "Котельнич",
    "population": 22508,
    "subject": "Кировская область"
    },
    {
    "coords": {
    "lat": "61.25",
    "lon": "46.65"
    },
    "district": "Северо-Западный",
    "name": "Котлас",
    "population": 62284,
    "subject": "Архангельская область"
    },
    {
    "coords": {
    "lat": "50.31667",
    "lon": "44.8"
    },
    "district": "Южный",
    "name": "Котово",
    "population": 21120,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "52.58333",
    "lon": "41.5"
    },
    "district": "Центральный",
    "name": "Котовск",
    "population": 28663,
    "subject": "Тамбовская область"
    },
    {
    "coords": {
    "lat": "56.93333",
    "lon": "41.08333"
    },
    "district": "Центральный",
    "name": "Кохма",
    "population": 30336,
    "subject": "Ивановская область"
    },
    {
    "coords": {
    "lat": "60.96667",
    "lon": "46.48333"
    },
    "district": "Северо-Западный",
    "name": "Красавино",
    "population": 5827,
    "subject": "Вологодская область"
    },
    {
    "coords": {
    "lat": "56.12278",
    "lon": "38.14611"
    },
    "district": "Центральный",
    "name": "Красноармейск",
    "population": 26449,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "51.01667",
    "lon": "45.7"
    },
    "district": "Приволжский",
    "name": "Красноармейск",
    "population": 22083,
    "subject": "Саратовская область"
    },
    {
    "coords": {
    "lat": "60.4",
    "lon": "57.06667"
    },
    "district": "Приволжский",
    "name": "Красновишерск",
    "population": 14683,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "55.81667",
    "lon": "37.33333"
    },
    "district": "Центральный",
    "name": "Красногорск",
    "population": 175812,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "45.03333",
    "lon": "38.98333"
    },
    "district": "Южный",
    "name": "Краснодар",
    "population": 948827,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "59.733745",
    "lon": "30.086205"
    },
    "district": "Северо-Западный",
    "name": "Красное Село",
    "population": 60029,
    "subject": "Санкт-Петербург"
    },
    {
    "coords": {
    "lat": "56.43806",
    "lon": "38.22944"
    },
    "district": "Центральный",
    "name": "Краснозаводск",
    "population": 12712,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "54.95",
    "lon": "22.5"
    },
    "district": "Северо-Западный",
    "name": "Краснознаменск",
    "population": 3049,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "55.6",
    "lon": "37.03333"
    },
    "district": "Центральный",
    "name": "Краснознаменск",
    "population": 43959,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "50.1",
    "lon": "118.03333"
    },
    "district": "Сибирский",
    "name": "Краснокаменск",
    "population": 51451,
    "subject": "Забайкальский край"
    },
    {
    "coords": {
    "lat": "58.08333",
    "lon": "55.75"
    },
    "district": "Приволжский",
    "name": "Краснокамск",
    "population": 51815,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "45.955306",
    "lon": "33.795"
    },
    "district": "Южный",
    "name": "Красноперекопск",
    "population": 24660,
    "subject": "Крым"
    },
    {
    "coords": {
    "lat": "48.7",
    "lon": "44.56667"
    },
    "district": "Южный",
    "name": "Краснослободск",
    "population": 8948,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "54.43333",
    "lon": "43.78333"
    },
    "district": "Приволжский",
    "name": "Краснослободск",
    "population": 16838,
    "subject": "Мордовия"
    },
    {
    "coords": {
    "lat": "59.76667",
    "lon": "60.2"
    },
    "district": "Уральский",
    "name": "Краснотурьинск",
    "population": 55910,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "58.35",
    "lon": "60.05"
    },
    "district": "Уральский",
    "name": "Красноуральск",
    "population": 22304,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "56.61667",
    "lon": "57.76667"
    },
    "district": "Уральский",
    "name": "Красноуфимск",
    "population": 37444,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "56.012083",
    "lon": "92.871295"
    },
    "district": "Сибирский",
    "name": "Красноярск",
    "population": 1103023,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "50.95",
    "lon": "46.96667"
    },
    "district": "Приволжский",
    "name": "Красный Кут",
    "population": 13966,
    "subject": "Саратовская область"
    },
    {
    "coords": {
    "lat": "47.88333",
    "lon": "40.06667"
    },
    "district": "Южный",
    "name": "Красный Сулин",
    "population": 37492,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "58.06329",
    "lon": "37.122983"
    },
    "district": "Центральный",
    "name": "Красный Холм",
    "population": 4950,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "54.88917",
    "lon": "37.12333"
    },
    "district": "Центральный",
    "name": "Кремёнки",
    "population": 10139,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "60",
    "lon": "29.76667"
    },
    "district": "Северо-Западный",
    "name": "Кронштадт",
    "population": 44353,
    "subject": "Санкт-Петербург"
    },
    {
    "coords": {
    "lat": "45.43333",
    "lon": "40.56667"
    },
    "district": "Южный",
    "name": "Кропоткин",
    "population": 77074,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "44.93333",
    "lon": "38"
    },
    "district": "Южный",
    "name": "Крымск",
    "population": 58051,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "56.15167",
    "lon": "44.19556"
    },
    "district": "Приволжский",
    "name": "Кстово",
    "population": 66928,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "55.57639",
    "lon": "36.69472"
    },
    "district": "Центральный",
    "name": "Кубинка",
    "population": 20417,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "51.48333",
    "lon": "57.35"
    },
    "district": "Приволжский",
    "name": "Кувандык",
    "population": 23225,
    "subject": "Оренбургская область"
    },
    {
    "coords": {
    "lat": "57.03333",
    "lon": "34.16667"
    },
    "district": "Центральный",
    "name": "Кувшиново",
    "population": 8853,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "59.908489",
    "lon": "30.513569"
    },
    "district": "Северо-Западный",
    "name": "Кудрово",
    "population": 49079,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "59.01667",
    "lon": "54.66667"
    },
    "district": "Приволжский",
    "name": "Кудымкар",
    "population": 29807,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "53.11667",
    "lon": "46.6"
    },
    "district": "Приволжский",
    "name": "Кузнецк",
    "population": 79800,
    "subject": "Пензенская область"
    },
    {
    "coords": {
    "lat": "55.45028",
    "lon": "78.3075"
    },
    "district": "Сибирский",
    "name": "Куйбышев",
    "population": 43195,
    "subject": "Новосибирская область"
    },
    {
    "coords": {
    "lat": "56.1825",
    "lon": "50.90639"
    },
    "district": "Приволжский",
    "name": "Кукмор",
    "population": 17790,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "55.41667",
    "lon": "42.51667"
    },
    "district": "Приволжский",
    "name": "Кулебаки",
    "population": 31509,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "52.76667",
    "lon": "55.78333"
    },
    "district": "Приволжский",
    "name": "Кумертау",
    "population": 59129,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "57.43333",
    "lon": "56.93333"
    },
    "district": "Приволжский",
    "name": "Кунгур",
    "population": 64259,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "54.36667",
    "lon": "77.3"
    },
    "district": "Сибирский",
    "name": "Купино",
    "population": 13711,
    "subject": "Новосибирская область"
    },
    {
    "coords": {
    "lat": "55.44083",
    "lon": "65.34111"
    },
    "district": "Уральский",
    "name": "Курган",
    "population": 309285,
    "subject": "Курганская область"
    },
    {
    "coords": {
    "lat": "44.88333",
    "lon": "40.6"
    },
    "district": "Южный",
    "name": "Курганинск",
    "population": 47975,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "45.25",
    "lon": "147.883333"
    },
    "district": "Дальневосточный",
    "name": "Курильск",
    "population": 1603,
    "subject": "Сахалинская область"
    },
    {
    "coords": {
    "lat": "55.45",
    "lon": "40.61667"
    },
    "district": "Центральный",
    "name": "Курлово",
    "population": 5639,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "55.58333",
    "lon": "38.91667"
    },
    "district": "Центральный",
    "name": "Куровское",
    "population": 20542,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "51.71667",
    "lon": "36.18333"
    },
    "district": "Центральный",
    "name": "Курск",
    "population": 450977,
    "subject": "Курская область"
    },
    {
    "coords": {
    "lat": "54.9",
    "lon": "64.43333"
    },
    "district": "Уральский",
    "name": "Куртамыш",
    "population": 16401,
    "subject": "Курганская область"
    },
    {
    "coords": {
    "lat": "43.20444",
    "lon": "46.087812"
    },
    "district": "Северо-Кавказский",
    "name": "Курчалой",
    "population": 27478,
    "subject": "Чечня"
    },
    {
    "coords": {
    "lat": "51.66667",
    "lon": "35.65"
    },
    "district": "Центральный",
    "name": "Курчатов",
    "population": 37940,
    "subject": "Курская область"
    },
    {
    "coords": {
    "lat": "55.33333",
    "lon": "59.43333"
    },
    "district": "Уральский",
    "name": "Куса",
    "population": 16497,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "58.28333",
    "lon": "59.73333"
    },
    "district": "Уральский",
    "name": "Кушва",
    "population": 26787,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "51.7",
    "lon": "94.36667"
    },
    "district": "Сибирский",
    "name": "Кызыл",
    "population": 120067,
    "subject": "Тыва"
    },
    {
    "coords": {
    "lat": "55.7",
    "lon": "60.55"
    },
    "district": "Уральский",
    "name": "Кыштым",
    "population": 35854,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "50.35",
    "lon": "106.45"
    },
    "district": "Сибирский",
    "name": "Кяхта",
    "population": 20654,
    "subject": "Бурятия"
    },
    {
    "coords": {
    "lat": "44.63333",
    "lon": "40.73333"
    },
    "district": "Южный",
    "name": "Лабинск",
    "population": 58498,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "66.65806",
    "lon": "66.38389"
    },
    "district": "Уральский",
    "name": "Лабытнанги",
    "population": 26520,
    "subject": "Ямало-Ненецкий АО"
    },
    {
    "coords": {
    "lat": "45.3925",
    "lon": "47.355"
    },
    "district": "Южный",
    "name": "Лагань",
    "population": 12684,
    "subject": "Калмыкия"
    },
    {
    "coords": {
    "lat": "54.56667",
    "lon": "20.16667"
    },
    "district": "Северо-Западный",
    "name": "Ладушкин",
    "population": 3820,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "55.4",
    "lon": "49.55"
    },
    "district": "Приволжский",
    "name": "Лаишево",
    "population": 8854,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "56.01694",
    "lon": "39.94944"
    },
    "district": "Центральный",
    "name": "Лакинск",
    "population": 13947,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "61.25",
    "lon": "75.16667"
    },
    "district": "Уральский",
    "name": "Лангепас",
    "population": 45063,
    "subject": "Ханты-Мансийский АО"
    },
    {
    "coords": {
    "lat": "61.51667",
    "lon": "30.2"
    },
    "district": "Северо-Западный",
    "name": "Лахденпохья",
    "population": 6890,
    "subject": "Карелия"
    },
    {
    "coords": {
    "lat": "53.0115528",
    "lon": "39.1281167"
    },
    "district": "Центральный",
    "name": "Лебедянь",
    "population": 19031,
    "subject": "Липецкая область"
    },
    {
    "coords": {
    "lat": "54.5988694",
    "lon": "52.4422722"
    },
    "district": "Приволжский",
    "name": "Лениногорск",
    "population": 61321,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "54.65",
    "lon": "86.16667"
    },
    "district": "Сибирский",
    "name": "Ленинск-Кузнецкий",
    "population": 93288,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "48.7",
    "lon": "45.2"
    },
    "district": "Южный",
    "name": "Ленинск",
    "population": 14366,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "60.71667",
    "lon": "114.9"
    },
    "district": "Дальневосточный",
    "name": "Ленск",
    "population": 23266,
    "subject": "Якутия"
    },
    {
    "coords": {
    "lat": "44.10528",
    "lon": "42.97167"
    },
    "district": "Северо-Кавказский",
    "name": "Лермонтов",
    "population": 23249,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "58.63333",
    "lon": "59.78333"
    },
    "district": "Уральский",
    "name": "Лесной",
    "population": 49259,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "45.46667",
    "lon": "133.4"
    },
    "district": "Дальневосточный",
    "name": "Лесозаводск",
    "population": 34827,
    "subject": "Приморский край"
    },
    {
    "coords": {
    "lat": "58.23333",
    "lon": "92.48333"
    },
    "district": "Сибирский",
    "name": "Лесосибирск",
    "population": 58949,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "52.425306",
    "lon": "37.608306"
    },
    "district": "Центральный",
    "name": "Ливны",
    "population": 47019,
    "subject": "Орловская область"
    },
    {
    "coords": {
    "lat": "55.71528",
    "lon": "38.95778"
    },
    "district": "Центральный",
    "name": "Ликино-Дулёво",
    "population": 28789,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "52.61667",
    "lon": "39.6"
    },
    "district": "Центральный",
    "name": "Липецк",
    "population": 503216,
    "subject": "Липецкая область"
    },
    {
    "coords": {
    "lat": "53.95",
    "lon": "37.7"
    },
    "district": "Центральный",
    "name": "Липки",
    "population": 8084,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "50.98222",
    "lon": "39.49944"
    },
    "district": "Центральный",
    "name": "Лиски",
    "population": 52823,
    "subject": "Воронежская область"
    },
    {
    "coords": {
    "lat": "57.11667",
    "lon": "35.46667"
    },
    "district": "Центральный",
    "name": "Лихославль",
    "population": 11285,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "56.01194",
    "lon": "37.47444"
    },
    "district": "Центральный",
    "name": "Лобня",
    "population": 89522,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "60.734305",
    "lon": "33.543183"
    },
    "district": "Северо-Западный",
    "name": "Лодейное Поле",
    "population": 18766,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "59.91667",
    "lon": "29.76667"
    },
    "district": "Северо-Западный",
    "name": "Ломоносов",
    "population": 43029,
    "subject": "Санкт-Петербург"
    },
    {
    "coords": {
    "lat": "55.86667",
    "lon": "38.2"
    },
    "district": "Центральный",
    "name": "Лосино-Петровский",
    "population": 25464,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "58.73333",
    "lon": "29.85"
    },
    "district": "Северо-Западный",
    "name": "Луга",
    "population": 33704,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "60.61667",
    "lon": "47.28333"
    },
    "district": "Приволжский",
    "name": "Луза",
    "population": 9658,
    "subject": "Кировская область"
    },
    {
    "coords": {
    "lat": "55.03833",
    "lon": "44.49778"
    },
    "district": "Приволжский",
    "name": "Лукоянов",
    "population": 13560,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "54.96667",
    "lon": "39.025"
    },
    "district": "Центральный",
    "name": "Луховицы",
    "population": 30383,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "56.01278",
    "lon": "45.02528"
    },
    "district": "Приволжский",
    "name": "Лысково",
    "population": 20828,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "58.1003806",
    "lon": "57.8043278"
    },
    "district": "Приволжский",
    "name": "Лысьва",
    "population": 59610,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "55.58361",
    "lon": "37.90556"
    },
    "district": "Центральный",
    "name": "Лыткарино",
    "population": 59937,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "51.66667",
    "lon": "35.26667"
    },
    "district": "Центральный",
    "name": "Льгов",
    "population": 17890,
    "subject": "Курская область"
    },
    {
    "coords": {
    "lat": "59.35",
    "lon": "31.25"
    },
    "district": "Северо-Западный",
    "name": "Любань",
    "population": 4324,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "55.68139",
    "lon": "37.89389"
    },
    "district": "Центральный",
    "name": "Люберцы",
    "population": 208397,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "58.35",
    "lon": "40.7"
    },
    "district": "Центральный",
    "name": "Любим",
    "population": 5021,
    "subject": "Ярославская область"
    },
    {
    "coords": {
    "lat": "53.86667",
    "lon": "34.46667"
    },
    "district": "Центральный",
    "name": "Людиново",
    "population": 36822,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "61.61667",
    "lon": "72.16667"
    },
    "district": "Уральский",
    "name": "Лянтор",
    "population": 41607,
    "subject": "Ханты-Мансийский АО"
    },
    {
    "coords": {
    "lat": "59.56667",
    "lon": "150.8"
    },
    "district": "Дальневосточный",
    "name": "Магадан",
    "population": 91797,
    "subject": "Магаданская область"
    },
    {
    "coords": {
    "lat": "43.16667",
    "lon": "44.81667"
    },
    "district": "Северо-Кавказский",
    "name": "Магас",
    "population": 13601,
    "subject": "Ингушетия"
    },
    {
    "coords": {
    "lat": "53.38333",
    "lon": "59.03333"
    },
    "district": "Уральский",
    "name": "Магнитогорск",
    "population": 413251,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "44.611",
    "lon": "40.111"
    },
    "district": "Южный",
    "name": "Майкоп",
    "population": 139084,
    "subject": "Адыгея"
    },
    {
    "coords": {
    "lat": "43.630508",
    "lon": "44.067733"
    },
    "district": "Северо-Кавказский",
    "name": "Майский",
    "population": 26318,
    "subject": "Кабардино-Балкария"
    },
    {
    "coords": {
    "lat": "48.61667",
    "lon": "142.78333"
    },
    "district": "Дальневосточный",
    "name": "Макаров",
    "population": 6091,
    "subject": "Сахалинская область"
    },
    {
    "coords": {
    "lat": "57.88333",
    "lon": "43.8"
    },
    "district": "Центральный",
    "name": "Макарьев",
    "population": 6266,
    "subject": "Костромская область"
    },
    {
    "coords": {
    "lat": "55.2",
    "lon": "67.25"
    },
    "district": "Уральский",
    "name": "Макушино",
    "population": 7680,
    "subject": "Курганская область"
    },
    {
    "coords": {
    "lat": "58.85",
    "lon": "32.21667"
    },
    "district": "Северо-Западный",
    "name": "Малая Вишера",
    "population": 10161,
    "subject": "Новгородская область"
    },
    {
    "coords": {
    "lat": "43.508882",
    "lon": "44.585563"
    },
    "district": "Северо-Кавказский",
    "name": "Малгобек",
    "population": 39096,
    "subject": "Ингушетия"
    },
    {
    "coords": {
    "lat": "56.52278",
    "lon": "50.68083"
    },
    "district": "Приволжский",
    "name": "Малмыж",
    "population": 7013,
    "subject": "Кировская область"
    },
    {
    "coords": {
    "lat": "52.4",
    "lon": "36.5"
    },
    "district": "Центральный",
    "name": "Малоархангельск",
    "population": 3141,
    "subject": "Орловская область"
    },
    {
    "coords": {
    "lat": "55",
    "lon": "36.46667"
    },
    "district": "Центральный",
    "name": "Малоярославец",
    "population": 27922,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "55.7",
    "lon": "51.4"
    },
    "district": "Приволжский",
    "name": "Мамадыш",
    "population": 15822,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "54.46667",
    "lon": "19.93333"
    },
    "district": "Северо-Западный",
    "name": "Мамоново",
    "population": 8104,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "58.33333",
    "lon": "44.76667"
    },
    "district": "Центральный",
    "name": "Мантурово",
    "population": 14747,
    "subject": "Костромская область"
    },
    {
    "coords": {
    "lat": "56.21667",
    "lon": "87.75"
    },
    "district": "Сибирский",
    "name": "Мариинск",
    "population": 37786,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "56.11667",
    "lon": "47.71667"
    },
    "district": "Приволжский",
    "name": "Мариинский Посад",
    "population": 8330,
    "subject": "Чувашия"
    },
    {
    "coords": {
    "lat": "51.7",
    "lon": "46.75"
    },
    "district": "Приволжский",
    "name": "Маркс",
    "population": 30241,
    "subject": "Саратовская область"
    },
    {
    "coords": {
    "lat": "42.98333",
    "lon": "47.5"
    },
    "district": "Северо-Кавказский",
    "name": "Махачкала",
    "population": 604266,
    "subject": "Дагестан"
    },
    {
    "coords": {
    "lat": "53.06111",
    "lon": "32.84833"
    },
    "district": "Центральный",
    "name": "Мглин",
    "population": 7177,
    "subject": "Брянская область"
    },
    {
    "coords": {
    "lat": "61.03306",
    "lon": "76.10972"
    },
    "district": "Уральский",
    "name": "Мегион",
    "population": 46188,
    "subject": "Ханты-Мансийский АО"
    },
    {
    "coords": {
    "lat": "62.91667",
    "lon": "34.45"
    },
    "district": "Северо-Западный",
    "name": "Медвежьегорск",
    "population": 13841,
    "subject": "Карелия"
    },
    {
    "coords": {
    "lat": "51.422085",
    "lon": "57.595296"
    },
    "district": "Приволжский",
    "name": "Медногорск",
    "population": 24321,
    "subject": "Оренбургская область"
    },
    {
    "coords": {
    "lat": "54.96667",
    "lon": "35.86667"
    },
    "district": "Центральный",
    "name": "Медынь",
    "population": 8370,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "54.24167",
    "lon": "57.96778"
    },
    "district": "Приволжский",
    "name": "Межгорье",
    "population": 15404,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "53.68333",
    "lon": "88.05"
    },
    "district": "Сибирский",
    "name": "Междуреченск",
    "population": 96088,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "65.85",
    "lon": "44.23333"
    },
    "district": "Северо-Западный",
    "name": "Мезень",
    "population": 3161,
    "subject": "Архангельская область"
    },
    {
    "coords": {
    "lat": "55.33333",
    "lon": "41.63333"
    },
    "district": "Центральный",
    "name": "Меленки",
    "population": 13269,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "52.95",
    "lon": "55.93333"
    },
    "district": "Приволжский",
    "name": "Мелеуз",
    "population": 56036,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "55.9",
    "lon": "52.31667"
    },
    "district": "Приволжский",
    "name": "Менделеевск",
    "population": 21840,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "55.71667",
    "lon": "53.08333"
    },
    "district": "Приволжский",
    "name": "Мензелинск",
    "population": 16840,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "54.31667",
    "lon": "35.28333"
    },
    "district": "Центральный",
    "name": "Мещовск",
    "population": 3803,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "55.05",
    "lon": "60.1"
    },
    "district": "Уральский",
    "name": "Миасс",
    "population": 150914,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "62.35",
    "lon": "50.06667"
    },
    "district": "Северо-Западный",
    "name": "Микунь",
    "population": 9400,
    "subject": "Коми"
    },
    {
    "coords": {
    "lat": "48.91667",
    "lon": "40.4"
    },
    "district": "Южный",
    "name": "Миллерово",
    "population": 33690,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "44.20083",
    "lon": "43.1125"
    },
    "district": "Северо-Кавказский",
    "name": "Минеральные Воды",
    "population": 73183,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "53.7",
    "lon": "91.68333"
    },
    "district": "Сибирский",
    "name": "Минусинск",
    "population": 67234,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "55.06667",
    "lon": "57.55"
    },
    "district": "Уральский",
    "name": "Миньяр",
    "population": 8768,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "62.76028",
    "lon": "40.33528"
    },
    "district": "Северо-Западный",
    "name": "Мирный",
    "population": 35416,
    "subject": "Архангельская область"
    },
    {
    "coords": {
    "lat": "62.53333",
    "lon": "113.95"
    },
    "district": "Дальневосточный",
    "name": "Мирный",
    "population": 33321,
    "subject": "Якутия"
    },
    {
    "coords": {
    "lat": "54.23333",
    "lon": "39.03333"
    },
    "district": "Центральный",
    "name": "Михайлов",
    "population": 9795,
    "subject": "Рязанская область"
    },
    {
    "coords": {
    "lat": "50.06667",
    "lon": "43.23333"
    },
    "district": "Южный",
    "name": "Михайловка",
    "population": 56981,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "56.43333",
    "lon": "59.11667"
    },
    "district": "Уральский",
    "name": "Михайловск",
    "population": 95525,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "45.130012",
    "lon": "42.027487"
    },
    "district": "Северо-Кавказский",
    "name": "Михайловск",
    "population": 8720,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "52.89222",
    "lon": "40.49278"
    },
    "district": "Центральный",
    "name": "Мичуринск",
    "population": 89876,
    "subject": "Тамбовская область"
    },
    {
    "coords": {
    "lat": "53.73333",
    "lon": "119.76667"
    },
    "district": "Сибирский",
    "name": "Могоча",
    "population": 12992,
    "subject": "Забайкальский край"
    },
    {
    "coords": {
    "lat": "55.5",
    "lon": "36.03333"
    },
    "district": "Центральный",
    "name": "Можайск",
    "population": 30052,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "56.45",
    "lon": "52.21667"
    },
    "district": "Приволжский",
    "name": "Можга",
    "population": 48750,
    "subject": "Удмуртия"
    },
    {
    "coords": {
    "lat": "43.74722",
    "lon": "44.65694"
    },
    "district": "Северо-Кавказский",
    "name": "Моздок",
    "population": 41459,
    "subject": "Северная Осетия"
    },
    {
    "coords": {
    "lat": "67.93944",
    "lon": "32.91556"
    },
    "district": "Северо-Западный",
    "name": "Мончегорск",
    "population": 40675,
    "subject": "Мурманская область"
    },
    {
    "coords": {
    "lat": "48.35",
    "lon": "41.83333"
    },
    "district": "Южный",
    "name": "Морозовск",
    "population": 24186,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "53.45",
    "lon": "41.8"
    },
    "district": "Центральный",
    "name": "Моршанск",
    "population": 37477,
    "subject": "Тамбовская область"
    },
    {
    "coords": {
    "lat": "54.48333",
    "lon": "34.98333"
    },
    "district": "Центральный",
    "name": "Мосальск",
    "population": 4250,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "55.75583",
    "lon": "37.61778"
    },
    "district": "Центральный",
    "name": "Москва",
    "population": 12655050,
    "subject": "Москва"
    },
    {
    "coords": {
    "lat": "55.6",
    "lon": "37.35"
    },
    "district": "Центральный",
    "name": "Московский",
    "population": 59196,
    "subject": "Москва"
    },
    {
    "coords": {
    "lat": "63.79444",
    "lon": "74.49722"
    },
    "district": "Уральский",
    "name": "Муравленко",
    "population": 31445,
    "subject": "Ямало-Ненецкий АО"
    },
    {
    "coords": {
    "lat": "59.38333",
    "lon": "48.96667"
    },
    "district": "Приволжский",
    "name": "Мураши",
    "population": 5739,
    "subject": "Кировская область"
    },
    {
    "coords": {
    "lat": "60.051284",
    "lon": "30.438578"
    },
    "district": "Северо-Западный",
    "name": "Мурино",
    "population": 78184,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "68.96667",
    "lon": "33.08333"
    },
    "district": "Северо-Западный",
    "name": "Мурманск",
    "population": 282851,
    "subject": "Мурманская область"
    },
    {
    "coords": {
    "lat": "55.5725",
    "lon": "42.05139"
    },
    "district": "Центральный",
    "name": "Муром",
    "population": 105572,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "53.27833",
    "lon": "36.575"
    },
    "district": "Центральный",
    "name": "Мценск",
    "population": 36179,
    "subject": "Орловская область"
    },
    {
    "coords": {
    "lat": "53.7",
    "lon": "87.81667"
    },
    "district": "Сибирский",
    "name": "Мыски",
    "population": 40549,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "55.91667",
    "lon": "37.73333"
    },
    "district": "Центральный",
    "name": "Мытищи",
    "population": 245643,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "57.78333",
    "lon": "38.45"
    },
    "district": "Центральный",
    "name": "Мышкин",
    "population": 5473,
    "subject": "Ярославская область"
    },
    {
    "coords": {
    "lat": "55.7",
    "lon": "52.33333"
    },
    "district": "Приволжский",
    "name": "Набережные Челны",
    "population": 532074,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "55.53333",
    "lon": "42.2"
    },
    "district": "Приволжский",
    "name": "Навашино",
    "population": 14436,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "57.46667",
    "lon": "41.96667"
    },
    "district": "Центральный",
    "name": "Наволоки",
    "population": 8988,
    "subject": "Ивановская область"
    },
    {
    "coords": {
    "lat": "65.53333",
    "lon": "72.51667"
    },
    "district": "Уральский",
    "name": "Надым",
    "population": 45584,
    "subject": "Ямало-Ненецкий АО"
    },
    {
    "coords": {
    "lat": "56.00639",
    "lon": "90.39139"
    },
    "district": "Сибирский",
    "name": "Назарово",
    "population": 49518,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "43.21667",
    "lon": "44.76667"
    },
    "district": "Северо-Кавказский",
    "name": "Назрань",
    "population": 124169,
    "subject": "Ингушетия"
    },
    {
    "coords": {
    "lat": "55.56667",
    "lon": "71.35"
    },
    "district": "Сибирский",
    "name": "Называевск",
    "population": 10709,
    "subject": "Омская область"
    },
    {
    "coords": {
    "lat": "43.485259",
    "lon": "43.607072"
    },
    "district": "Северо-Кавказский",
    "name": "Нальчик",
    "population": 239054,
    "subject": "Кабардино-Балкария"
    },
    {
    "coords": {
    "lat": "46.68333",
    "lon": "47.85"
    },
    "district": "Южный",
    "name": "Нариманов",
    "population": 10601,
    "subject": "Астраханская область"
    },
    {
    "coords": {
    "lat": "55.38333",
    "lon": "36.73333"
    },
    "district": "Центральный",
    "name": "Наро-Фоминск",
    "population": 67009,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "43.556734",
    "lon": "43.862222"
    },
    "district": "Северо-Кавказский",
    "name": "Нарткала",
    "population": 30464,
    "subject": "Кабардино-Балкария"
    },
    {
    "coords": {
    "lat": "67.63778",
    "lon": "53.00667"
    },
    "district": "Северо-Западный",
    "name": "Нарьян-Мар",
    "population": 25536,
    "subject": "Ненецкий АО"
    },
    {
    "coords": {
    "lat": "42.81667",
    "lon": "132.88333"
    },
    "district": "Дальневосточный",
    "name": "Находка",
    "population": 142673,
    "subject": "Приморский край"
    },
    {
    "coords": {
    "lat": "56.01667",
    "lon": "29.93333"
    },
    "district": "Северо-Западный",
    "name": "Невель",
    "population": 14241,
    "subject": "Псковская область"
    },
    {
    "coords": {
    "lat": "46.65",
    "lon": "141.86667"
    },
    "district": "Дальневосточный",
    "name": "Невельск",
    "population": 9679,
    "subject": "Сахалинская область"
    },
    {
    "coords": {
    "lat": "44.63333",
    "lon": "41.93333"
    },
    "district": "Северо-Кавказский",
    "name": "Невинномысск",
    "population": 115627,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "57.48333",
    "lon": "60.2"
    },
    "district": "Уральский",
    "name": "Невьянск",
    "population": 22900,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "56.21667",
    "lon": "32.78333"
    },
    "district": "Центральный",
    "name": "Нелидово",
    "population": 17639,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "55.03333",
    "lon": "22.03333"
    },
    "district": "Северо-Западный",
    "name": "Неман",
    "population": 10765,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "57.45",
    "lon": "40.58333"
    },
    "district": "Центральный",
    "name": "Нерехта",
    "population": 20635,
    "subject": "Костромская область"
    },
    {
    "coords": {
    "lat": "51.98333",
    "lon": "116.58333"
    },
    "district": "Сибирский",
    "name": "Нерчинск",
    "population": 14648,
    "subject": "Забайкальский край"
    },
    {
    "coords": {
    "lat": "56.65833",
    "lon": "124.725"
    },
    "district": "Дальневосточный",
    "name": "Нерюнгри",
    "population": 58969,
    "subject": "Якутия"
    },
    {
    "coords": {
    "lat": "54.63333",
    "lon": "22.56667"
    },
    "district": "Северо-Западный",
    "name": "Нестеров",
    "population": 3937,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "52.8",
    "lon": "51.16667"
    },
    "district": "Приволжский",
    "name": "Нефтегорск",
    "population": 17806,
    "subject": "Самарская область"
    },
    {
    "coords": {
    "lat": "56.08889",
    "lon": "54.24639"
    },
    "district": "Приволжский",
    "name": "Нефтекамск",
    "population": 131945,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "44.75056",
    "lon": "44.97972"
    },
    "district": "Северо-Кавказский",
    "name": "Нефтекумск",
    "population": 24316,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "61.1",
    "lon": "72.6"
    },
    "district": "Уральский",
    "name": "Нефтеюганск",
    "population": 128159,
    "subject": "Ханты-Мансийский АО"
    },
    {
    "coords": {
    "lat": "58.29444",
    "lon": "43.87806"
    },
    "district": "Центральный",
    "name": "Нея",
    "population": 8474,
    "subject": "Костромская область"
    },
    {
    "coords": {
    "lat": "60.93389",
    "lon": "76.58111"
    },
    "district": "Уральский",
    "name": "Нижневартовск",
    "population": 278725,
    "subject": "Ханты-Мансийский АО"
    },
    {
    "coords": {
    "lat": "55.63333",
    "lon": "51.81667"
    },
    "district": "Приволжский",
    "name": "Нижнекамск",
    "population": 240097,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "54.9",
    "lon": "99.01667"
    },
    "district": "Сибирский",
    "name": "Нижнеудинск",
    "population": 32858,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "56.66667",
    "lon": "59.3"
    },
    "district": "Уральский",
    "name": "Нижние Серги",
    "population": 8891,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "53.53333",
    "lon": "43.68333"
    },
    "district": "Приволжский",
    "name": "Нижний Ломов",
    "population": 20175,
    "subject": "Пензенская область"
    },
    {
    "coords": {
    "lat": "56.32694",
    "lon": "44.0075"
    },
    "district": "Приволжский",
    "name": "Нижний Новгород",
    "population": 1244254,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "57.91667",
    "lon": "59.96667"
    },
    "district": "Уральский",
    "name": "Нижний Тагил",
    "population": 344656,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "58.08333",
    "lon": "60.71667"
    },
    "district": "Уральский",
    "name": "Нижняя Салда",
    "population": 17229,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "58.62083",
    "lon": "59.84778"
    },
    "district": "Уральский",
    "name": "Нижняя Тура",
    "population": 19091,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "53.15",
    "lon": "140.73333"
    },
    "district": "Дальневосточный",
    "name": "Николаевск-на-Амуре",
    "population": 17668,
    "subject": "Хабаровский край"
    },
    {
    "coords": {
    "lat": "50.02722",
    "lon": "45.46306"
    },
    "district": "Южный",
    "name": "Николаевск",
    "population": 13310,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "59.53333",
    "lon": "45.45"
    },
    "district": "Северо-Западный",
    "name": "Никольск",
    "population": 7960,
    "subject": "Вологодская область"
    },
    {
    "coords": {
    "lat": "53.71667",
    "lon": "46.08333"
    },
    "district": "Приволжский",
    "name": "Никольск",
    "population": 19357,
    "subject": "Пензенская область"
    },
    {
    "coords": {
    "lat": "59.7",
    "lon": "30.78333"
    },
    "district": "Северо-Западный",
    "name": "Никольское",
    "population": 21949,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "60.106401",
    "lon": "32.316183"
    },
    "district": "Северо-Западный",
    "name": "Новая Ладога",
    "population": 7806,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "59.05",
    "lon": "60.6"
    },
    "district": "Уральский",
    "name": "Новая Ляля",
    "population": 11596,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "45.49333",
    "lon": "41.21694"
    },
    "district": "Северо-Кавказский",
    "name": "Новоалександровск",
    "population": 26354,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "53.4",
    "lon": "83.93333"
    },
    "district": "Сибирский",
    "name": "Новоалтайск",
    "population": 74586,
    "subject": "Алтайский край"
    },
    {
    "coords": {
    "lat": "50.51667",
    "lon": "42.66667"
    },
    "district": "Южный",
    "name": "Новоаннинский",
    "population": 15791,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "51.31667",
    "lon": "39.21667"
    },
    "district": "Центральный",
    "name": "Нововоронеж",
    "population": 31558,
    "subject": "Воронежская область"
    },
    {
    "coords": {
    "lat": "64.41667",
    "lon": "40.81667"
    },
    "district": "Северо-Западный",
    "name": "Новодвинск",
    "population": 37256,
    "subject": "Архангельская область"
    },
    {
    "coords": {
    "lat": "52.53333",
    "lon": "31.93333"
    },
    "district": "Центральный",
    "name": "Новозыбков",
    "population": 39449,
    "subject": "Брянская область"
    },
    {
    "coords": {
    "lat": "45.1",
    "lon": "41.05"
    },
    "district": "Южный",
    "name": "Новокубанск",
    "population": 34925,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "53.73333",
    "lon": "87.08333"
    },
    "district": "Сибирский",
    "name": "Новокузнецк",
    "population": 544583,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "53.1",
    "lon": "49.91667"
    },
    "district": "Приволжский",
    "name": "Новокуйбышевск",
    "population": 99469,
    "subject": "Самарская область"
    },
    {
    "coords": {
    "lat": "54.03333",
    "lon": "39.75"
    },
    "district": "Центральный",
    "name": "Новомичуринск",
    "population": 16327,
    "subject": "Рязанская область"
    },
    {
    "coords": {
    "lat": "54.03333",
    "lon": "38.26667"
    },
    "district": "Центральный",
    "name": "Новомосковск",
    "population": 121674,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "43.96361",
    "lon": "43.63944"
    },
    "district": "Северо-Кавказский",
    "name": "Новопавловск",
    "population": 26054,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "57.03333",
    "lon": "29.33333"
    },
    "district": "Северо-Западный",
    "name": "Новоржев",
    "population": 3070,
    "subject": "Псковская область"
    },
    {
    "coords": {
    "lat": "44.71667",
    "lon": "37.76667"
    },
    "district": "Южный",
    "name": "Новороссийск",
    "population": 275795,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "55.01667",
    "lon": "82.91667"
    },
    "district": "Сибирский",
    "name": "Новосибирск",
    "population": 1620162,
    "subject": "Новосибирская область"
    },
    {
    "coords": {
    "lat": "52.96667",
    "lon": "37.05"
    },
    "district": "Центральный",
    "name": "Новосиль",
    "population": 3087,
    "subject": "Орловская область"
    },
    {
    "coords": {
    "lat": "56.33333",
    "lon": "30.15"
    },
    "district": "Северо-Западный",
    "name": "Новосокольники",
    "population": 6900,
    "subject": "Псковская область"
    },
    {
    "coords": {
    "lat": "51.20667",
    "lon": "58.32806"
    },
    "district": "Приволжский",
    "name": "Новотроицк",
    "population": 82463,
    "subject": "Оренбургская область"
    },
    {
    "coords": {
    "lat": "50.45",
    "lon": "48.15"
    },
    "district": "Приволжский",
    "name": "Новоузенск",
    "population": 14945,
    "subject": "Саратовская область"
    },
    {
    "coords": {
    "lat": "54.15",
    "lon": "48.38333"
    },
    "district": "Приволжский",
    "name": "Новоульяновск",
    "population": 13588,
    "subject": "Ульяновская область"
    },
    {
    "coords": {
    "lat": "57.25",
    "lon": "60.08333"
    },
    "district": "Уральский",
    "name": "Новоуральск",
    "population": 79638,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "51.1",
    "lon": "41.61667"
    },
    "district": "Центральный",
    "name": "Новохопёрск",
    "population": 5805,
    "subject": "Воронежская область"
    },
    {
    "coords": {
    "lat": "56.12194",
    "lon": "47.4925"
    },
    "district": "Приволжский",
    "name": "Новочебоксарск",
    "population": 127586,
    "subject": "Чувашия"
    },
    {
    "coords": {
    "lat": "47.43583",
    "lon": "40.09861"
    },
    "district": "Южный",
    "name": "Новочеркасск",
    "population": 166312,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "47.76667",
    "lon": "39.91667"
    },
    "district": "Южный",
    "name": "Новошахтинск",
    "population": 105038,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "50.76667",
    "lon": "37.86667"
    },
    "district": "Центральный",
    "name": "Новый Оскол",
    "population": 18443,
    "subject": "Белгородская область"
    },
    {
    "coords": {
    "lat": "66.08472",
    "lon": "76.67889"
    },
    "district": "Уральский",
    "name": "Новый Уренгой",
    "population": 118115,
    "subject": "Ямало-Ненецкий АО"
    },
    {
    "coords": {
    "lat": "55.85",
    "lon": "38.43333"
    },
    "district": "Центральный",
    "name": "Ногинск",
    "population": 103063,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "57.55722",
    "lon": "49.93417"
    },
    "district": "Приволжский",
    "name": "Нолинск",
    "population": 9460,
    "subject": "Кировская область"
    },
    {
    "coords": {
    "lat": "69.33333",
    "lon": "88.21667"
    },
    "district": "Сибирский",
    "name": "Норильск",
    "population": 182701,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "63.20167",
    "lon": "75.45167"
    },
    "district": "Уральский",
    "name": "Ноябрьск",
    "population": 108376,
    "subject": "Ямало-Ненецкий АО"
    },
    {
    "coords": {
    "lat": "54.43333",
    "lon": "50.8"
    },
    "district": "Приволжский",
    "name": "Нурлат",
    "population": 31555,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "57.93333",
    "lon": "55.33333"
    },
    "district": "Приволжский",
    "name": "Нытва",
    "population": 17976,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "63.28333",
    "lon": "118.33333"
    },
    "district": "Дальневосточный",
    "name": "Нюрба",
    "population": 9761,
    "subject": "Якутия"
    },
    {
    "coords": {
    "lat": "62.13333",
    "lon": "65.38333"
    },
    "district": "Уральский",
    "name": "Нягань",
    "population": 58733,
    "subject": "Ханты-Мансийский АО"
    },
    {
    "coords": {
    "lat": "56.05",
    "lon": "59.6"
    },
    "district": "Уральский",
    "name": "Нязепетровск",
    "population": 11301,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "61.66667",
    "lon": "40.2"
    },
    "district": "Северо-Западный",
    "name": "Няндома",
    "population": 18857,
    "subject": "Архангельская область"
    },
    {
    "coords": {
    "lat": "49",
    "lon": "131.05"
    },
    "district": "Дальневосточный",
    "name": "Облучье",
    "population": 8264,
    "subject": "Еврейская АО"
    },
    {
    "coords": {
    "lat": "55.1",
    "lon": "36.61667"
    },
    "district": "Центральный",
    "name": "Обнинск",
    "population": 116179,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "51.21111",
    "lon": "36.27639"
    },
    "district": "Центральный",
    "name": "Обоянь",
    "population": 13162,
    "subject": "Курская область"
    },
    {
    "coords": {
    "lat": "54.99167",
    "lon": "82.7125"
    },
    "district": "Сибирский",
    "name": "Обь",
    "population": 30131,
    "subject": "Новосибирская область"
    },
    {
    "coords": {
    "lat": "55.67333",
    "lon": "37.27333"
    },
    "district": "Центральный",
    "name": "Одинцово",
    "population": 135867,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "54.41667",
    "lon": "22.01667"
    },
    "district": "Северо-Западный",
    "name": "Озёрск",
    "population": 3816,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "55.75",
    "lon": "60.71667"
    },
    "district": "Уральский",
    "name": "Озёрск",
    "population": 78128,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "54.857875",
    "lon": "38.5438194"
    },
    "district": "Центральный",
    "name": "Озёры",
    "population": 24468,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "53.16667",
    "lon": "48.66667"
    },
    "district": "Приволжский",
    "name": "Октябрьск",
    "population": 25771,
    "subject": "Самарская область"
    },
    {
    "coords": {
    "lat": "54.48333",
    "lon": "53.48333"
    },
    "district": "Приволжский",
    "name": "Октябрьский",
    "population": 113737,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "58.38333",
    "lon": "33.3"
    },
    "district": "Северо-Западный",
    "name": "Окуловка",
    "population": 9510,
    "subject": "Новгородская область"
    },
    {
    "coords": {
    "lat": "68.15",
    "lon": "33.28333"
    },
    "district": "Северо-Западный",
    "name": "Оленегорск",
    "population": 19887,
    "subject": "Мурманская область"
    },
    {
    "coords": {
    "lat": "60.98333",
    "lon": "32.96667"
    },
    "district": "Северо-Западный",
    "name": "Олонец",
    "population": 7942,
    "subject": "Карелия"
    },
    {
    "coords": {
    "lat": "60.38333",
    "lon": "120.43333"
    },
    "district": "Дальневосточный",
    "name": "Олёкминск",
    "population": 9102,
    "subject": "Якутия"
    },
    {
    "coords": {
    "lat": "54.96667",
    "lon": "73.38333"
    },
    "district": "Сибирский",
    "name": "Омск",
    "population": 1139897,
    "subject": "Омская область"
    },
    {
    "coords": {
    "lat": "58.66667",
    "lon": "52.18333"
    },
    "district": "Приволжский",
    "name": "Омутнинск",
    "population": 21431,
    "subject": "Кировская область"
    },
    {
    "coords": {
    "lat": "63.91667",
    "lon": "38.08333"
    },
    "district": "Северо-Западный",
    "name": "Онега",
    "population": 18149,
    "subject": "Архангельская область"
    },
    {
    "coords": {
    "lat": "56.71667",
    "lon": "28.65"
    },
    "district": "Северо-Западный",
    "name": "Опочка",
    "population": 9089,
    "subject": "Псковская область"
    },
    {
    "coords": {
    "lat": "51.76667",
    "lon": "55.1"
    },
    "district": "Приволжский",
    "name": "Оренбург",
    "population": 572819,
    "subject": "Оренбургская область"
    },
    {
    "coords": {
    "lat": "55.8",
    "lon": "38.96667"
    },
    "district": "Центральный",
    "name": "Орехово-Зуево",
    "population": 117966,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "58.53889",
    "lon": "48.89861"
    },
    "district": "Приволжский",
    "name": "Орлов",
    "population": 6335,
    "subject": "Кировская область"
    },
    {
    "coords": {
    "lat": "51.2",
    "lon": "58.61667"
    },
    "district": "Приволжский",
    "name": "Орск",
    "population": 224814,
    "subject": "Оренбургская область"
    },
    {
    "coords": {
    "lat": "52.96667",
    "lon": "36.08333"
    },
    "district": "Центральный",
    "name": "Орёл",
    "population": 303696,
    "subject": "Орловская область"
    },
    {
    "coords": {
    "lat": "57.28333",
    "lon": "55.45"
    },
    "district": "Приволжский",
    "name": "Оса",
    "population": 20782,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "53.61667",
    "lon": "87.33333"
    },
    "district": "Сибирский",
    "name": "Осинники",
    "population": 41274,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "57.15",
    "lon": "33.1"
    },
    "district": "Центральный",
    "name": "Осташков",
    "population": 15187,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "57.33333",
    "lon": "28.35"
    },
    "district": "Северо-Западный",
    "name": "Остров",
    "population": 20531,
    "subject": "Псковская область"
    },
    {
    "coords": {
    "lat": "68.05306",
    "lon": "39.51306"
    },
    "district": "Северо-Западный",
    "name": "Островной",
    "population": 1640,
    "subject": "Мурманская область"
    },
    {
    "coords": {
    "lat": "50.86667",
    "lon": "39.06667"
    },
    "district": "Центральный",
    "name": "Острогожск",
    "population": 31476,
    "subject": "Воронежская область"
    },
    {
    "coords": {
    "lat": "59.77409",
    "lon": "30.794553"
    },
    "district": "Северо-Западный",
    "name": "Отрадное",
    "population": 26030,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "53.36667",
    "lon": "51.35"
    },
    "district": "Приволжский",
    "name": "Отрадный",
    "population": 47055,
    "subject": "Самарская область"
    },
    {
    "coords": {
    "lat": "53.58333",
    "lon": "142.95"
    },
    "district": "Дальневосточный",
    "name": "Оха",
    "population": 19783,
    "subject": "Сахалинская область"
    },
    {
    "coords": {
    "lat": "57.71667",
    "lon": "55.38333"
    },
    "district": "Приволжский",
    "name": "Оханск",
    "population": 6955,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "57.88333",
    "lon": "54.71667"
    },
    "district": "Приволжский",
    "name": "Очёр",
    "population": 14246,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "55.96194",
    "lon": "43.09"
    },
    "district": "Приволжский",
    "name": "Павлово",
    "population": 56129,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "50.45",
    "lon": "40.06667"
    },
    "district": "Центральный",
    "name": "Павловск",
    "population": 24191,
    "subject": "Воронежская область"
    },
    {
    "coords": {
    "lat": "59.68333",
    "lon": "30.43333"
    },
    "district": "Северо-Западный",
    "name": "Павловск",
    "population": 17223,
    "subject": "Санкт-Петербург"
    },
    {
    "coords": {
    "lat": "55.78333",
    "lon": "38.65"
    },
    "district": "Центральный",
    "name": "Павловский Посад",
    "population": 62718,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "50.05",
    "lon": "46.88333"
    },
    "district": "Южный",
    "name": "Палласовка",
    "population": 14248,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "43.13333",
    "lon": "133.13333"
    },
    "district": "Дальневосточный",
    "name": "Партизанск",
    "population": 36247,
    "subject": "Приморский край"
    },
    {
    "coords": {
    "lat": "69.7",
    "lon": "170.31667"
    },
    "district": "Дальневосточный",
    "name": "Певек",
    "population": 4513,
    "subject": "Чукотский АО"
    },
    {
    "coords": {
    "lat": "53.2",
    "lon": "45"
    },
    "district": "Приволжский",
    "name": "Пенза",
    "population": 516450,
    "subject": "Пензенская область"
    },
    {
    "coords": {
    "lat": "54.86667",
    "lon": "43.8"
    },
    "district": "Приволжский",
    "name": "Первомайск",
    "population": 13101,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "56.91667",
    "lon": "59.95"
    },
    "district": "Уральский",
    "name": "Первоуральск",
    "population": 119365,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "55.6",
    "lon": "44.55"
    },
    "district": "Приволжский",
    "name": "Перевоз",
    "population": 8611,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "56.41667",
    "lon": "38.18333"
    },
    "district": "Центральный",
    "name": "Пересвет",
    "population": 13293,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "56.7381333",
    "lon": "38.8561528"
    },
    "district": "Центральный",
    "name": "Переславль-Залесский",
    "population": 37391,
    "subject": "Ярославская область"
    },
    {
    "coords": {
    "lat": "58.01389",
    "lon": "56.24889"
    },
    "district": "Приволжский",
    "name": "Пермь",
    "population": 1049199,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "58.6",
    "lon": "35.81667"
    },
    "district": "Северо-Западный",
    "name": "Пестово",
    "population": 14842,
    "subject": "Новгородская область"
    },
    {
    "coords": {
    "lat": "59.88333",
    "lon": "29.9"
    },
    "district": "Северо-Западный",
    "name": "Петергоф",
    "population": 84930,
    "subject": "Санкт-Петербург"
    },
    {
    "coords": {
    "lat": "50.13333",
    "lon": "45.21667"
    },
    "district": "Южный",
    "name": "Петров Вал",
    "population": 12285,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "51.28333",
    "lon": "108.83333"
    },
    "district": "Сибирский",
    "name": "Петровск-Забайкальский",
    "population": 15626,
    "subject": "Забайкальский край"
    },
    {
    "coords": {
    "lat": "52.31667",
    "lon": "45.38333"
    },
    "district": "Приволжский",
    "name": "Петровск",
    "population": 27987,
    "subject": "Саратовская область"
    },
    {
    "coords": {
    "lat": "61.79611",
    "lon": "34.34917"
    },
    "district": "Северо-Западный",
    "name": "Петрозаводск",
    "population": 280711,
    "subject": "Карелия"
    },
    {
    "coords": {
    "lat": "53.01667",
    "lon": "158.65"
    },
    "district": "Дальневосточный",
    "name": "Петропавловск-Камчатский",
    "population": 179367,
    "subject": "Камчатский край"
    },
    {
    "coords": {
    "lat": "55.06667",
    "lon": "67.88333"
    },
    "district": "Уральский",
    "name": "Петухово",
    "population": 9916,
    "subject": "Курганская область"
    },
    {
    "coords": {
    "lat": "55.93333",
    "lon": "39.46667"
    },
    "district": "Центральный",
    "name": "Петушки",
    "population": 12166,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "65.11667",
    "lon": "57.11667"
    },
    "district": "Северо-Западный",
    "name": "Печора",
    "population": 37556,
    "subject": "Коми"
    },
    {
    "coords": {
    "lat": "57.81667",
    "lon": "27.6"
    },
    "district": "Северо-Западный",
    "name": "Печоры",
    "population": 9003,
    "subject": "Псковская область"
    },
    {
    "coords": {
    "lat": "59.512684",
    "lon": "34.177483"
    },
    "district": "Северо-Западный",
    "name": "Пикалёво",
    "population": 19490,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "54.95",
    "lon": "20.21667"
    },
    "district": "Северо-Западный",
    "name": "Пионерский",
    "population": 12573,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "61.56667",
    "lon": "31.48333"
    },
    "district": "Северо-Западный",
    "name": "Питкяранта",
    "population": 10048,
    "subject": "Карелия"
    },
    {
    "coords": {
    "lat": "53.7",
    "lon": "37.3"
    },
    "district": "Центральный",
    "name": "Плавск",
    "population": 15563,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "54.36667",
    "lon": "60.81667"
    },
    "district": "Уральский",
    "name": "Пласт",
    "population": 17101,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "57.45",
    "lon": "41.5"
    },
    "district": "Центральный",
    "name": "Плёс",
    "population": 1734,
    "subject": "Ивановская область"
    },
    {
    "coords": {
    "lat": "51.2",
    "lon": "42.25"
    },
    "district": "Центральный",
    "name": "Поворино",
    "population": 16706,
    "subject": "Воронежская область"
    },
    {
    "coords": {
    "lat": "55.42972",
    "lon": "37.54444"
    },
    "district": "Центральный",
    "name": "Подольск",
    "population": 309250,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "60.912097",
    "lon": "34.167952"
    },
    "district": "Северо-Западный",
    "name": "Подпорожье",
    "population": 16462,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "61.75",
    "lon": "75.58333"
    },
    "district": "Уральский",
    "name": "Покачи",
    "population": 18217,
    "subject": "Ханты-Мансийский АО"
    },
    {
    "coords": {
    "lat": "55.91778",
    "lon": "39.175"
    },
    "district": "Центральный",
    "name": "Покров",
    "population": 16542,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "61.48333",
    "lon": "129.15"
    },
    "district": "Дальневосточный",
    "name": "Покровск",
    "population": 9507,
    "subject": "Якутия"
    },
    {
    "coords": {
    "lat": "56.45",
    "lon": "60.18333"
    },
    "district": "Уральский",
    "name": "Полевской",
    "population": 60012,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "54.86667",
    "lon": "21.1"
    },
    "district": "Северо-Западный",
    "name": "Полесск",
    "population": 6921,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "54.6",
    "lon": "86.28333"
    },
    "district": "Сибирский",
    "name": "Полысаево",
    "population": 25638,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "67.36583",
    "lon": "32.49806"
    },
    "district": "Северо-Западный",
    "name": "Полярные Зори",
    "population": 14230,
    "subject": "Мурманская область"
    },
    {
    "coords": {
    "lat": "69.19833",
    "lon": "33.45611"
    },
    "district": "Северо-Западный",
    "name": "Полярный",
    "population": 17280,
    "subject": "Мурманская область"
    },
    {
    "coords": {
    "lat": "49.21667",
    "lon": "143.1"
    },
    "district": "Дальневосточный",
    "name": "Поронайск",
    "population": 15777,
    "subject": "Сахалинская область"
    },
    {
    "coords": {
    "lat": "57.76667",
    "lon": "29.55"
    },
    "district": "Северо-Западный",
    "name": "Порхов",
    "population": 8095,
    "subject": "Псковская область"
    },
    {
    "coords": {
    "lat": "53.65",
    "lon": "52.13333"
    },
    "district": "Приволжский",
    "name": "Похвистнево",
    "population": 27665,
    "subject": "Самарская область"
    },
    {
    "coords": {
    "lat": "52.93333",
    "lon": "33.45"
    },
    "district": "Центральный",
    "name": "Почеп",
    "population": 16209,
    "subject": "Брянская область"
    },
    {
    "coords": {
    "lat": "54.4",
    "lon": "32.45"
    },
    "district": "Центральный",
    "name": "Починок",
    "population": 8171,
    "subject": "Смоленская область"
    },
    {
    "coords": {
    "lat": "58.5",
    "lon": "39.11667"
    },
    "district": "Центральный",
    "name": "Пошехонье",
    "population": 5639,
    "subject": "Ярославская область"
    },
    {
    "coords": {
    "lat": "54.45",
    "lon": "21.01667"
    },
    "district": "Северо-Западный",
    "name": "Правдинск",
    "population": 4045,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "57.38333",
    "lon": "41.28333"
    },
    "district": "Центральный",
    "name": "Приволжск",
    "population": 15085,
    "subject": "Ивановская область"
    },
    {
    "coords": {
    "lat": "54.73333",
    "lon": "20"
    },
    "district": "Северо-Западный",
    "name": "Приморск",
    "population": 1921,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "60.366014",
    "lon": "28.613561"
    },
    "district": "Северо-Западный",
    "name": "Приморск",
    "population": 5405,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "46.05",
    "lon": "38.18333"
    },
    "district": "Южный",
    "name": "Приморско-Ахтарск",
    "population": 32020,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "61.03333",
    "lon": "30.11667"
    },
    "district": "Северо-Западный",
    "name": "Приозерск",
    "population": 17685,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "53.88333",
    "lon": "86.71667"
    },
    "district": "Сибирский",
    "name": "Прокопьевск",
    "population": 187877,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "46.70306",
    "lon": "41.71917"
    },
    "district": "Южный",
    "name": "Пролетарск",
    "population": 18549,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "54.87944",
    "lon": "37.21389"
    },
    "district": "Центральный",
    "name": "Протвино",
    "population": 34879,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "43.750055",
    "lon": "44.033333"
    },
    "district": "Северо-Кавказский",
    "name": "Прохладный",
    "population": 58747,
    "subject": "Кабардино-Балкария"
    },
    {
    "coords": {
    "lat": "57.81667",
    "lon": "28.33333"
    },
    "district": "Северо-Западный",
    "name": "Псков",
    "population": 209426,
    "subject": "Псковская область"
    },
    {
    "coords": {
    "lat": "52.01667",
    "lon": "48.8"
    },
    "district": "Приволжский",
    "name": "Пугачёв",
    "population": 40425,
    "subject": "Саратовская область"
    },
    {
    "coords": {
    "lat": "61.8",
    "lon": "36.53333"
    },
    "district": "Северо-Западный",
    "name": "Пудож",
    "population": 8513,
    "subject": "Карелия"
    },
    {
    "coords": {
    "lat": "56.33333",
    "lon": "29.36667"
    },
    "district": "Северо-Западный",
    "name": "Пустошка",
    "population": 3829,
    "subject": "Псковская область"
    },
    {
    "coords": {
    "lat": "56.98333",
    "lon": "43.16667"
    },
    "district": "Центральный",
    "name": "Пучеж",
    "population": 6010,
    "subject": "Ивановская область"
    },
    {
    "coords": {
    "lat": "59.71667",
    "lon": "30.41667"
    },
    "district": "Северо-Западный",
    "name": "Пушкин",
    "population": 112978,
    "subject": "Санкт-Петербург"
    },
    {
    "coords": {
    "lat": "56.01667",
    "lon": "37.85"
    },
    "district": "Центральный",
    "name": "Пушкино",
    "population": 108741,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "54.83333",
    "lon": "37.61667"
    },
    "district": "Центральный",
    "name": "Пущино",
    "population": 20583,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "57.06667",
    "lon": "27.91667"
    },
    "district": "Северо-Западный",
    "name": "Пыталово",
    "population": 5392,
    "subject": "Псковская область"
    },
    {
    "coords": {
    "lat": "60.75",
    "lon": "72.78333"
    },
    "district": "Уральский",
    "name": "Пыть-Ях",
    "population": 39436,
    "subject": "Ханты-Мансийский АО"
    },
    {
    "coords": {
    "lat": "44.0499664",
    "lon": "43.0600548"
    },
    "district": "Северо-Кавказский",
    "name": "Пятигорск",
    "population": 146267,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "55.99778",
    "lon": "40.32972"
    },
    "district": "Центральный",
    "name": "Радужный",
    "population": 18470,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "62.13333",
    "lon": "77.46667"
    },
    "district": "Уральский",
    "name": "Радужный",
    "population": 44127,
    "subject": "Ханты-Мансийский АО"
    },
    {
    "coords": {
    "lat": "49.8",
    "lon": "129.4"
    },
    "district": "Дальневосточный",
    "name": "Райчихинск",
    "population": 16479,
    "subject": "Амурская область"
    },
    {
    "coords": {
    "lat": "55.56667",
    "lon": "38.21667"
    },
    "district": "Центральный",
    "name": "Раменское",
    "population": 123590,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "52.66667",
    "lon": "41.88333"
    },
    "district": "Центральный",
    "name": "Рассказово",
    "population": 42293,
    "subject": "Тамбовская область"
    },
    {
    "coords": {
    "lat": "56.8",
    "lon": "59.91667"
    },
    "district": "Уральский",
    "name": "Ревда",
    "population": 60761,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "57.36667",
    "lon": "61.4"
    },
    "district": "Уральский",
    "name": "Реж",
    "population": 36420,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "55.76667",
    "lon": "37.86667"
    },
    "district": "Центральный",
    "name": "Реутов",
    "population": 108000,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "56.2655833",
    "lon": "34.3275694"
    },
    "district": "Центральный",
    "name": "Ржев",
    "population": 56399,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "57.1",
    "lon": "41.73333"
    },
    "district": "Центральный",
    "name": "Родники",
    "population": 23895,
    "subject": "Ивановская область"
    },
    {
    "coords": {
    "lat": "53.94917",
    "lon": "32.85694"
    },
    "district": "Центральный",
    "name": "Рославль",
    "population": 48228,
    "subject": "Смоленская область"
    },
    {
    "coords": {
    "lat": "50.2",
    "lon": "39.58333"
    },
    "district": "Центральный",
    "name": "Россошь",
    "population": 62290,
    "subject": "Воронежская область"
    },
    {
    "coords": {
    "lat": "47.24056",
    "lon": "39.71056"
    },
    "district": "Южный",
    "name": "Ростов-на-Дону",
    "population": 1137704,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "57.18333",
    "lon": "39.41667"
    },
    "district": "Центральный",
    "name": "Ростов",
    "population": 30406,
    "subject": "Ярославская область"
    },
    {
    "coords": {
    "lat": "55.66361",
    "lon": "39.865"
    },
    "district": "Центральный",
    "name": "Рошаль",
    "population": 19823,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "52.25",
    "lon": "43.78333"
    },
    "district": "Приволжский",
    "name": "Ртищево",
    "population": 38030,
    "subject": "Саратовская область"
    },
    {
    "coords": {
    "lat": "51.52722",
    "lon": "81.218806"
    },
    "district": "Сибирский",
    "name": "Рубцовск",
    "population": 139565,
    "subject": "Алтайский край"
    },
    {
    "coords": {
    "lat": "54.95",
    "lon": "31.06667"
    },
    "district": "Центральный",
    "name": "Рудня",
    "population": 9413,
    "subject": "Смоленская область"
    },
    {
    "coords": {
    "lat": "55.69889",
    "lon": "36.19528"
    },
    "district": "Центральный",
    "name": "Руза",
    "population": 12476,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "54.06667",
    "lon": "44.95"
    },
    "district": "Приволжский",
    "name": "Рузаевка",
    "population": 43685,
    "subject": "Мордовия"
    },
    {
    "coords": {
    "lat": "58.05",
    "lon": "38.83333"
    },
    "district": "Центральный",
    "name": "Рыбинск",
    "population": 182383,
    "subject": "Ярославская область"
    },
    {
    "coords": {
    "lat": "54.73333",
    "lon": "39.51667"
    },
    "district": "Центральный",
    "name": "Рыбное",
    "population": 20949,
    "subject": "Рязанская область"
    },
    {
    "coords": {
    "lat": "51.56667",
    "lon": "34.68333"
    },
    "district": "Центральный",
    "name": "Рыльск",
    "population": 15986,
    "subject": "Курская область"
    },
    {
    "coords": {
    "lat": "53.71667",
    "lon": "40.06667"
    },
    "district": "Центральный",
    "name": "Ряжск",
    "population": 20641,
    "subject": "Рязанская область"
    },
    {
    "coords": {
    "lat": "54.61667",
    "lon": "39.71667"
    },
    "district": "Центральный",
    "name": "Рязань",
    "population": 534801,
    "subject": "Рязанская область"
    },
    {
    "coords": {
    "lat": "45.13361",
    "lon": "33.57722"
    },
    "district": "Южный",
    "name": "Саки",
    "population": 24282,
    "subject": "Крым"
    },
    {
    "coords": {
    "lat": "53.36667",
    "lon": "55.93333"
    },
    "district": "Приволжский",
    "name": "Салават",
    "population": 148947,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "54.23333",
    "lon": "85.8"
    },
    "district": "Сибирский",
    "name": "Салаир",
    "population": 7169,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "66.53333",
    "lon": "66.63333"
    },
    "district": "Уральский",
    "name": "Салехард",
    "population": 51186,
    "subject": "Ямало-Ненецкий АО"
    },
    {
    "coords": {
    "lat": "46.48333",
    "lon": "41.53333"
    },
    "district": "Южный",
    "name": "Сальск",
    "population": 56247,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "53.18333",
    "lon": "50.11667"
    },
    "district": "Приволжский",
    "name": "Самара",
    "population": 1144759,
    "subject": "Самарская область"
    },
    {
    "coords": {
    "lat": "59.95",
    "lon": "30.31667"
    },
    "district": "Северо-Западный",
    "name": "Санкт-Петербург",
    "population": 5384342,
    "subject": "Санкт-Петербург"
    },
    {
    "coords": {
    "lat": "54.18333",
    "lon": "45.18333"
    },
    "district": "Приволжский",
    "name": "Саранск",
    "population": 317432,
    "subject": "Мордовия"
    },
    {
    "coords": {
    "lat": "56.46667",
    "lon": "53.8"
    },
    "district": "Приволжский",
    "name": "Сарапул",
    "population": 94554,
    "subject": "Удмуртия"
    },
    {
    "coords": {
    "lat": "51.53333",
    "lon": "46"
    },
    "district": "Приволжский",
    "name": "Саратов",
    "population": 830155,
    "subject": "Саратовская область"
    },
    {
    "coords": {
    "lat": "54.93333",
    "lon": "43.31667"
    },
    "district": "Приволжский",
    "name": "Саров",
    "population": 96479,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "54.35",
    "lon": "41.91667"
    },
    "district": "Центральный",
    "name": "Сасово",
    "population": 23213,
    "subject": "Рязанская область"
    },
    {
    "coords": {
    "lat": "55.05",
    "lon": "59.05"
    },
    "district": "Уральский",
    "name": "Сатка",
    "population": 40808,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "55.1",
    "lon": "33.25"
    },
    "district": "Центральный",
    "name": "Сафоново",
    "population": 40537,
    "subject": "Смоленская область"
    },
    {
    "coords": {
    "lat": "53.1",
    "lon": "91.4"
    },
    "district": "Сибирский",
    "name": "Саяногорск",
    "population": 45384,
    "subject": "Хакасия"
    },
    {
    "coords": {
    "lat": "54.11667",
    "lon": "102.16667"
    },
    "district": "Сибирский",
    "name": "Саянск",
    "population": 38899,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "54.93333",
    "lon": "20.15"
    },
    "district": "Северо-Западный",
    "name": "Светлогорск",
    "population": 16099,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "45.33083",
    "lon": "42.85111"
    },
    "district": "Северо-Кавказский",
    "name": "Светлоград",
    "population": 34896,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "54.68333",
    "lon": "20.13333"
    },
    "district": "Северо-Западный",
    "name": "Светлый",
    "population": 21441,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "61.10833",
    "lon": "28.85833"
    },
    "district": "Северо-Западный",
    "name": "Светогорск",
    "population": 14982,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "53.08333",
    "lon": "103.33333"
    },
    "district": "Сибирский",
    "name": "Свирск",
    "population": 12686,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "51.38333",
    "lon": "128.13333"
    },
    "district": "Дальневосточный",
    "name": "Свободный",
    "population": 52918,
    "subject": "Амурская область"
    },
    {
    "coords": {
    "lat": "56.28333",
    "lon": "28.48333"
    },
    "district": "Северо-Западный",
    "name": "Себеж",
    "population": 5197,
    "subject": "Псковская область"
    },
    {
    "coords": {
    "lat": "44.6",
    "lon": "33.53333"
    },
    "district": "Южный",
    "name": "Севастополь",
    "population": 509992,
    "subject": "Севастополь"
    },
    {
    "coords": {
    "lat": "50.66667",
    "lon": "156.11667"
    },
    "district": "Дальневосточный",
    "name": "Северо-Курильск",
    "population": 2691,
    "subject": "Сахалинская область"
    },
    {
    "coords": {
    "lat": "55.63333",
    "lon": "109.31667"
    },
    "district": "Сибирский",
    "name": "Северобайкальск",
    "population": 23304,
    "subject": "Бурятия"
    },
    {
    "coords": {
    "lat": "64.56667",
    "lon": "39.85"
    },
    "district": "Северо-Западный",
    "name": "Северодвинск",
    "population": 180806,
    "subject": "Архангельская область"
    },
    {
    "coords": {
    "lat": "69.06917",
    "lon": "33.41667"
    },
    "district": "Северо-Западный",
    "name": "Североморск",
    "population": 54473,
    "subject": "Мурманская область"
    },
    {
    "coords": {
    "lat": "60.15",
    "lon": "59.93333"
    },
    "district": "Уральский",
    "name": "Североуральск",
    "population": 25157,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "56.6",
    "lon": "84.85"
    },
    "district": "Сибирский",
    "name": "Северск",
    "population": 105858,
    "subject": "Томская область"
    },
    {
    "coords": {
    "lat": "52.15",
    "lon": "34.49389"
    },
    "district": "Центральный",
    "name": "Севск",
    "population": 6510,
    "subject": "Брянская область"
    },
    {
    "coords": {
    "lat": "63.73333",
    "lon": "34.31667"
    },
    "district": "Северо-Западный",
    "name": "Сегежа",
    "population": 25585,
    "subject": "Карелия"
    },
    {
    "coords": {
    "lat": "53.36944",
    "lon": "34.1"
    },
    "district": "Центральный",
    "name": "Сельцо",
    "population": 16159,
    "subject": "Брянская область"
    },
    {
    "coords": {
    "lat": "47.51667",
    "lon": "40.8"
    },
    "district": "Южный",
    "name": "Семикаракорск",
    "population": 21826,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "51.68333",
    "lon": "39.03333"
    },
    "district": "Центральный",
    "name": "Семилуки",
    "population": 27139,
    "subject": "Воронежская область"
    },
    {
    "coords": {
    "lat": "56.78944",
    "lon": "44.49056"
    },
    "district": "Приволжский",
    "name": "Семёнов",
    "population": 23902,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "53.96667",
    "lon": "48.8"
    },
    "district": "Приволжский",
    "name": "Сенгилей",
    "population": 6182,
    "subject": "Ульяновская область"
    },
    {
    "coords": {
    "lat": "49.58333",
    "lon": "42.73333"
    },
    "district": "Южный",
    "name": "Серафимович",
    "population": 8578,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "55.53333",
    "lon": "45.46667"
    },
    "district": "Приволжский",
    "name": "Сергач",
    "population": 19843,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "56.3",
    "lon": "38.13333"
    },
    "district": "Центральный",
    "name": "Сергиев Посад",
    "population": 98784,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "52.46667",
    "lon": "44.21667"
    },
    "district": "Приволжский",
    "name": "Сердобск",
    "population": 30420,
    "subject": "Пензенская область"
    },
    {
    "coords": {
    "lat": "59.58333",
    "lon": "60.56667"
    },
    "district": "Уральский",
    "name": "Серов",
    "population": 95141,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "54.91667",
    "lon": "37.4"
    },
    "district": "Центральный",
    "name": "Серпухов",
    "population": 125473,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "60.141613",
    "lon": "30.211879"
    },
    "district": "Северо-Западный",
    "name": "Сертолово",
    "population": 58802,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "60.1",
    "lon": "29.96667"
    },
    "district": "Северо-Западный",
    "name": "Сестрорецк",
    "population": 43060,
    "subject": "Санкт-Петербург"
    },
    {
    "coords": {
    "lat": "52.7",
    "lon": "58.65"
    },
    "district": "Приволжский",
    "name": "Сибай",
    "population": 60017,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "54.98333",
    "lon": "57.68333"
    },
    "district": "Уральский",
    "name": "Сим",
    "population": 12235,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "44.94806",
    "lon": "34.10417"
    },
    "district": "Южный",
    "name": "Симферополь",
    "population": 336212,
    "subject": "Крым"
    },
    {
    "coords": {
    "lat": "53.98333",
    "lon": "123.93333"
    },
    "district": "Дальневосточный",
    "name": "Сковородино",
    "population": 8745,
    "subject": "Амурская область"
    },
    {
    "coords": {
    "lat": "53.81667",
    "lon": "39.55"
    },
    "district": "Центральный",
    "name": "Скопин",
    "population": 25433,
    "subject": "Рязанская область"
    },
    {
    "coords": {
    "lat": "53",
    "lon": "78.65"
    },
    "district": "Сибирский",
    "name": "Славгород",
    "population": 28757,
    "subject": "Алтайский край"
    },
    {
    "coords": {
    "lat": "55.05",
    "lon": "21.66667"
    },
    "district": "Северо-Западный",
    "name": "Славск",
    "population": 3964,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "45.25861",
    "lon": "38.12472"
    },
    "district": "Южный",
    "name": "Славянск-на-Кубани",
    "population": 67777,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "59.11779",
    "lon": "28.088145"
    },
    "district": "Северо-Западный",
    "name": "Сланцы",
    "population": 31985,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "58.724167",
    "lon": "50.161167"
    },
    "district": "Приволжский",
    "name": "Слободской",
    "population": 31465,
    "subject": "Кировская область"
    },
    {
    "coords": {
    "lat": "51.66667",
    "lon": "103.7"
    },
    "district": "Сибирский",
    "name": "Слюдянка",
    "population": 18139,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "54.78278",
    "lon": "32.04528"
    },
    "district": "Центральный",
    "name": "Смоленск",
    "population": 320170,
    "subject": "Смоленская область"
    },
    {
    "coords": {
    "lat": "56.08333",
    "lon": "60.73333"
    },
    "district": "Уральский",
    "name": "Снежинск",
    "population": 51921,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "69.19417",
    "lon": "33.23306"
    },
    "district": "Северо-Западный",
    "name": "Снежногорск",
    "population": 12982,
    "subject": "Мурманская область"
    },
    {
    "coords": {
    "lat": "55.99",
    "lon": "40.01667"
    },
    "district": "Центральный",
    "name": "Собинка",
    "population": 16973,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "55.08333",
    "lon": "21.88333"
    },
    "district": "Северо-Западный",
    "name": "Советск",
    "population": 38514,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "57.601306",
    "lon": "48.938611"
    },
    "district": "Приволжский",
    "name": "Советск",
    "population": 15118,
    "subject": "Кировская область"
    },
    {
    "coords": {
    "lat": "53.93333",
    "lon": "37.63333"
    },
    "district": "Центральный",
    "name": "Советск",
    "population": 7246,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "48.966373",
    "lon": "140.285189"
    },
    "district": "Дальневосточный",
    "name": "Советская Гавань",
    "population": 23245,
    "subject": "Хабаровский край"
    },
    {
    "coords": {
    "lat": "61.36667",
    "lon": "63.56667"
    },
    "district": "Уральский",
    "name": "Советский",
    "population": 29452,
    "subject": "Ханты-Мансийский АО — Югра"
    },
    {
    "coords": {
    "lat": "59.46667",
    "lon": "40.11667"
    },
    "district": "Северо-Западный",
    "name": "Сокол",
    "population": 36067,
    "subject": "Вологодская область"
    },
    {
    "coords": {
    "lat": "59.08333",
    "lon": "42.28333"
    },
    "district": "Центральный",
    "name": "Солигалич",
    "population": 5912,
    "subject": "Костромская область"
    },
    {
    "coords": {
    "lat": "59.63333",
    "lon": "56.76667"
    },
    "district": "Приволжский",
    "name": "Соликамск",
    "population": 91959,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "56.18444",
    "lon": "36.995"
    },
    "district": "Центральный",
    "name": "Солнечногорск",
    "population": 49389,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "51.16667",
    "lon": "54.98333"
    },
    "district": "Приволжский",
    "name": "Соль-Илецк",
    "population": 26655,
    "subject": "Оренбургская область"
    },
    {
    "coords": {
    "lat": "61.33333",
    "lon": "46.91667"
    },
    "district": "Северо-Западный",
    "name": "Сольвычегодск",
    "population": 1833,
    "subject": "Архангельская область"
    },
    {
    "coords": {
    "lat": "58.11667",
    "lon": "30.31667"
    },
    "district": "Северо-Западный",
    "name": "Сольцы",
    "population": 8336,
    "subject": "Новгородская область"
    },
    {
    "coords": {
    "lat": "52.43333",
    "lon": "53.15"
    },
    "district": "Приволжский",
    "name": "Сорочинск",
    "population": 26980,
    "subject": "Оренбургская область"
    },
    {
    "coords": {
    "lat": "54",
    "lon": "90.25"
    },
    "district": "Сибирский",
    "name": "Сорск",
    "population": 11103,
    "subject": "Хакасия"
    },
    {
    "coords": {
    "lat": "61.7",
    "lon": "30.66667"
    },
    "district": "Северо-Западный",
    "name": "Сортавала",
    "population": 18704,
    "subject": "Карелия"
    },
    {
    "coords": {
    "lat": "54.05",
    "lon": "35.96667"
    },
    "district": "Центральный",
    "name": "Сосенский",
    "population": 10291,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "56.2543",
    "lon": "51.2812"
    },
    "district": "Приволжский",
    "name": "Сосновка",
    "population": 10610,
    "subject": "Кировская область"
    },
    {
    "coords": {
    "lat": "56.13333",
    "lon": "93.36667"
    },
    "district": "Сибирский",
    "name": "Сосновоборск",
    "population": 41152,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "59.9",
    "lon": "29.08611"
    },
    "district": "Северо-Западный",
    "name": "Сосновый Бор",
    "population": 67054,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "63.58333",
    "lon": "53.93333"
    },
    "district": "Северо-Западный",
    "name": "Сосногорск",
    "population": 25795,
    "subject": "Коми"
    },
    {
    "coords": {
    "lat": "43.58528",
    "lon": "39.72028"
    },
    "district": "Южный",
    "name": "Сочи",
    "population": 432322,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "54.40980806",
    "lon": "34.01899194"
    },
    "district": "Центральный",
    "name": "Спас-Деменск",
    "population": 4286,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "55.13333",
    "lon": "40.16667"
    },
    "district": "Центральный",
    "name": "Спас-Клепики",
    "population": 5084,
    "subject": "Рязанская область"
    },
    {
    "coords": {
    "lat": "44.6",
    "lon": "132.81667"
    },
    "district": "Дальневосточный",
    "name": "Спасск-Дальний",
    "population": 39311,
    "subject": "Приморский край"
    },
    {
    "coords": {
    "lat": "54.4",
    "lon": "40.38333"
    },
    "district": "Центральный",
    "name": "Спасск-Рязанский",
    "population": 6567,
    "subject": "Рязанская область"
    },
    {
    "coords": {
    "lat": "53.93333",
    "lon": "43.18333"
    },
    "district": "Приволжский",
    "name": "Спасск",
    "population": 6966,
    "subject": "Пензенская область"
    },
    {
    "coords": {
    "lat": "67.458",
    "lon": "153.706"
    },
    "district": "Дальневосточный",
    "name": "Среднеколымск",
    "population": 3470,
    "subject": "Якутия"
    },
    {
    "coords": {
    "lat": "56.98333",
    "lon": "60.46667"
    },
    "district": "Уральский",
    "name": "Среднеуральск",
    "population": 23889,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "52.25",
    "lon": "117.71667"
    },
    "district": "Сибирский",
    "name": "Сретенск",
    "population": 6353,
    "subject": "Забайкальский край"
    },
    {
    "coords": {
    "lat": "45.03333",
    "lon": "41.96667"
    },
    "district": "Северо-Кавказский",
    "name": "Ставрополь",
    "population": 454488,
    "subject": "Ставропольский край"
    },
    {
    "coords": {
    "lat": "55.8",
    "lon": "38.18333"
    },
    "district": "Центральный",
    "name": "Старая Купавна",
    "population": 22692,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "57.98333",
    "lon": "31.35"
    },
    "district": "Северо-Западный",
    "name": "Старая Русса",
    "population": 27377,
    "subject": "Новгородская область"
    },
    {
    "coords": {
    "lat": "56.51667",
    "lon": "34.93333"
    },
    "district": "Центральный",
    "name": "Старица",
    "population": 7222,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "52.58333",
    "lon": "32.76667"
    },
    "district": "Центральный",
    "name": "Стародуб",
    "population": 18086,
    "subject": "Брянская область"
    },
    {
    "coords": {
    "lat": "45.02917",
    "lon": "35.08861"
    },
    "district": "Южный",
    "name": "Старый Крым",
    "population": 9381,
    "subject": "Крым"
    },
    {
    "coords": {
    "lat": "51.29806",
    "lon": "37.835"
    },
    "district": "Центральный",
    "name": "Старый Оскол",
    "population": 223711,
    "subject": "Белгородская область"
    },
    {
    "coords": {
    "lat": "53.63333",
    "lon": "55.95"
    },
    "district": "Приволжский",
    "name": "Стерлитамак",
    "population": 274134,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "60.73333",
    "lon": "77.58333"
    },
    "district": "Сибирский",
    "name": "Стрежевой",
    "population": 39903,
    "subject": "Томская область"
    },
    {
    "coords": {
    "lat": "50.78333",
    "lon": "36.48333"
    },
    "district": "Центральный",
    "name": "Строитель",
    "population": 23923,
    "subject": "Белгородская область"
    },
    {
    "coords": {
    "lat": "56.37333",
    "lon": "38.585"
    },
    "district": "Центральный",
    "name": "Струнино",
    "population": 12754,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "53.18333",
    "lon": "50.11667"
    },
    "district": "Центральный",
    "name": "Ступино",
    "population": 65660,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "54.11667",
    "lon": "36.5"
    },
    "district": "Центральный",
    "name": "Суворов",
    "population": 17006,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "44.85139",
    "lon": "34.9725"
    },
    "district": "Южный",
    "name": "Судак",
    "population": 16235,
    "subject": "Крым"
    },
    {
    "coords": {
    "lat": "51.190694",
    "lon": "35.27083"
    },
    "district": "Центральный",
    "name": "Суджа",
    "population": 5554,
    "subject": "Курская область"
    },
    {
    "coords": {
    "lat": "55.95",
    "lon": "40.86667"
    },
    "district": "Центральный",
    "name": "Судогда",
    "population": 10017,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "56.42111",
    "lon": "40.44889"
    },
    "district": "Центральный",
    "name": "Суздаль",
    "population": 9597,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "43.313475",
    "lon": "45.051581"
    },
    "district": "Северо-Кавказский",
    "name": "Сунжа",
    "population": 66807,
    "subject": "Ингушетия"
    },
    {
    "coords": {
    "lat": "62.08333",
    "lon": "32.36667"
    },
    "district": "Северо-Западный",
    "name": "Суоярви",
    "population": 8607,
    "subject": "Карелия"
    },
    {
    "coords": {
    "lat": "53.01667",
    "lon": "32.4"
    },
    "district": "Центральный",
    "name": "Сураж",
    "population": 10556,
    "subject": "Брянская область"
    },
    {
    "coords": {
    "lat": "61.25",
    "lon": "73.43333"
    },
    "district": "Уральский",
    "name": "Сургут",
    "population": 387235,
    "subject": "Ханты-Мансийский АО"
    },
    {
    "coords": {
    "lat": "48.6",
    "lon": "42.85"
    },
    "district": "Южный",
    "name": "Суровикино",
    "population": 18154,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "53.08333",
    "lon": "45.7"
    },
    "district": "Приволжский",
    "name": "Сурск",
    "population": 5725,
    "subject": "Пензенская область"
    },
    {
    "coords": {
    "lat": "62.78333",
    "lon": "148.15"
    },
    "district": "Дальневосточный",
    "name": "Сусуман",
    "population": 4273,
    "subject": "Магаданская область"
    },
    {
    "coords": {
    "lat": "54.1",
    "lon": "35.35"
    },
    "district": "Центральный",
    "name": "Сухиничи",
    "population": 14629,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "56.90583",
    "lon": "62.03417"
    },
    "district": "Уральский",
    "name": "Сухой Лог",
    "population": 33048,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "53.16667",
    "lon": "48.46667"
    },
    "district": "Приволжский",
    "name": "Сызрань",
    "population": 165199,
    "subject": "Самарская область"
    },
    {
    "coords": {
    "lat": "61.66667",
    "lon": "50.81667"
    },
    "district": "Северо-Западный",
    "name": "Сыктывкар",
    "population": 243926,
    "subject": "Коми"
    },
    {
    "coords": {
    "lat": "56.5",
    "lon": "60.81667"
    },
    "district": "Уральский",
    "name": "Сысерть",
    "population": 21029,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "55.83333",
    "lon": "34.28333"
    },
    "district": "Центральный",
    "name": "Сычёвка",
    "population": 8394,
    "subject": "Смоленская область"
    },
    {
    "coords": {
    "lat": "60.137057",
    "lon": "32.561279"
    },
    "district": "Северо-Западный",
    "name": "Сясьстрой",
    "population": 12203,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "58.05",
    "lon": "65.26667"
    },
    "district": "Уральский",
    "name": "Тавда",
    "population": 32338,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "47.23917",
    "lon": "38.88333"
    },
    "district": "Южный",
    "name": "Таганрог",
    "population": 248269,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "56.06667",
    "lon": "85.61667"
    },
    "district": "Сибирский",
    "name": "Тайга",
    "population": 22619,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "55.93333",
    "lon": "98.01667"
    },
    "district": "Сибирский",
    "name": "Тайшет",
    "population": 32592,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "56.73333",
    "lon": "37.53333"
    },
    "district": "Центральный",
    "name": "Талдом",
    "population": 12575,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "57.0125",
    "lon": "63.72917"
    },
    "district": "Уральский",
    "name": "Талица",
    "population": 15486,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "52.71667",
    "lon": "41.43333"
    },
    "district": "Центральный",
    "name": "Тамбов",
    "population": 289701,
    "subject": "Тамбовская область"
    },
    {
    "coords": {
    "lat": "56.902383",
    "lon": "74.37079"
    },
    "district": "Сибирский",
    "name": "Тара",
    "population": 28268,
    "subject": "Омская область"
    },
    {
    "coords": {
    "lat": "64.91472",
    "lon": "77.77278"
    },
    "district": "Уральский",
    "name": "Тарко-Сале",
    "population": 21664,
    "subject": "Ямало-Ненецкий АО"
    },
    {
    "coords": {
    "lat": "54.71667",
    "lon": "37.18333"
    },
    "district": "Центральный",
    "name": "Таруса",
    "population": 9126,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "55.21667",
    "lon": "75.96667"
    },
    "district": "Сибирский",
    "name": "Татарск",
    "population": 23282,
    "subject": "Новосибирская область"
    },
    {
    "coords": {
    "lat": "52.76667",
    "lon": "87.86667"
    },
    "district": "Сибирский",
    "name": "Таштагол",
    "population": 22647,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "56.8578278",
    "lon": "35.9219278"
    },
    "district": "Центральный",
    "name": "Тверь",
    "population": 424969,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "43.449437",
    "lon": "41.74382"
    },
    "district": "Северо-Кавказский",
    "name": "Теберда",
    "population": 8672,
    "subject": "Карачаево-Черкесия"
    },
    {
    "coords": {
    "lat": "56.85",
    "lon": "40.55"
    },
    "district": "Центральный",
    "name": "Тейково",
    "population": 31623,
    "subject": "Ивановская область"
    },
    {
    "coords": {
    "lat": "54.63333",
    "lon": "43.21667"
    },
    "district": "Приволжский",
    "name": "Темников",
    "population": 5561,
    "subject": "Мордовия"
    },
    {
    "coords": {
    "lat": "45.26667",
    "lon": "37.38333"
    },
    "district": "Южный",
    "name": "Темрюк",
    "population": 41281,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "43.483317",
    "lon": "44.138871"
    },
    "district": "Северо-Кавказский",
    "name": "Терек",
    "population": 19643,
    "subject": "Кабардино-Балкария"
    },
    {
    "coords": {
    "lat": "54.93333",
    "lon": "48.83333"
    },
    "district": "Приволжский",
    "name": "Тетюши",
    "population": 10804,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "45.61667",
    "lon": "38.93333"
    },
    "district": "Южный",
    "name": "Тимашёвск",
    "population": 50566,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "59.644213",
    "lon": "33.542105"
    },
    "district": "Северо-Западный",
    "name": "Тихвин",
    "population": 57327,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "45.85",
    "lon": "40.11667"
    },
    "district": "Южный",
    "name": "Тихорецк",
    "population": 56262,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "58.19528",
    "lon": "68.25806"
    },
    "district": "Уральский",
    "name": "Тобольск",
    "population": 98772,
    "subject": "Тюменская область"
    },
    {
    "coords": {
    "lat": "55.23333",
    "lon": "84.38333"
    },
    "district": "Сибирский",
    "name": "Тогучин",
    "population": 20489,
    "subject": "Новосибирская область"
    },
    {
    "coords": {
    "lat": "53.51667",
    "lon": "49.41667"
    },
    "district": "Приволжский",
    "name": "Тольятти",
    "population": 693072,
    "subject": "Самарская область"
    },
    {
    "coords": {
    "lat": "47.76667",
    "lon": "142.06667"
    },
    "district": "Дальневосточный",
    "name": "Томари",
    "population": 3788,
    "subject": "Сахалинская область"
    },
    {
    "coords": {
    "lat": "58.96667",
    "lon": "126.26667"
    },
    "district": "Дальневосточный",
    "name": "Томмот",
    "population": 6694,
    "subject": "Якутия"
    },
    {
    "coords": {
    "lat": "56.48861",
    "lon": "84.95222"
    },
    "district": "Сибирский",
    "name": "Томск",
    "population": 568508,
    "subject": "Томская область"
    },
    {
    "coords": {
    "lat": "55.28333",
    "lon": "85.61667"
    },
    "district": "Сибирский",
    "name": "Топки",
    "population": 27673,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "57.03333",
    "lon": "34.96667"
    },
    "district": "Центральный",
    "name": "Торжок",
    "population": 43614,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "56.5",
    "lon": "31.63333"
    },
    "district": "Центральный",
    "name": "Торопец",
    "population": 11527,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "59.541179",
    "lon": "30.875006"
    },
    "district": "Северо-Западный",
    "name": "Тосно",
    "population": 35099,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "59.98333",
    "lon": "42.76667"
    },
    "district": "Северо-Западный",
    "name": "Тотьма",
    "population": 9652,
    "subject": "Вологодская область"
    },
    {
    "coords": {
    "lat": "55.467",
    "lon": "37.3"
    },
    "district": "Центральный",
    "name": "Троицк",
    "population": 61097,
    "subject": "Москва"
    },
    {
    "coords": {
    "lat": "54.08333",
    "lon": "61.56667"
    },
    "district": "Уральский",
    "name": "Троицк",
    "population": 72723,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "52.58333",
    "lon": "33.76667"
    },
    "district": "Центральный",
    "name": "Трубчевск",
    "population": 13515,
    "subject": "Брянская область"
    },
    {
    "coords": {
    "lat": "54.8",
    "lon": "58.45"
    },
    "district": "Уральский",
    "name": "Трёхгорный",
    "population": 32571,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "44.100016",
    "lon": "39.083223"
    },
    "district": "Южный",
    "name": "Туапсе",
    "population": 60987,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "54.6",
    "lon": "53.7"
    },
    "district": "Приволжский",
    "name": "Туймазы",
    "population": 68108,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "54.2",
    "lon": "37.61667"
    },
    "district": "Центральный",
    "name": "Тула",
    "population": 467955,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "54.56667",
    "lon": "100.56667"
    },
    "district": "Сибирский",
    "name": "Тулун",
    "population": 38466,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "52.1446",
    "lon": "93.9181"
    },
    "district": "Сибирский",
    "name": "Туран",
    "population": 4916,
    "subject": "Тыва"
    },
    {
    "coords": {
    "lat": "58.03333",
    "lon": "63.7"
    },
    "district": "Уральский",
    "name": "Туринск",
    "population": 16999,
    "subject": "Свердловская область"
    },
    {
    "coords": {
    "lat": "57.88333",
    "lon": "39.53333"
    },
    "district": "Центральный",
    "name": "Тутаев",
    "population": 39749,
    "subject": "Ярославская область"
    },
    {
    "coords": {
    "lat": "55.15",
    "lon": "124.71667"
    },
    "district": "Дальневосточный",
    "name": "Тында",
    "population": 32894,
    "subject": "Амурская область"
    },
    {
    "coords": {
    "lat": "43.3892665",
    "lon": "42.9189065"
    },
    "district": "Северо-Кавказский",
    "name": "Тырныауз",
    "population": 20661,
    "subject": "Кабардино-Балкария"
    },
    {
    "coords": {
    "lat": "55.86667",
    "lon": "72.2"
    },
    "district": "Сибирский",
    "name": "Тюкалинск",
    "population": 10159,
    "subject": "Омская область"
    },
    {
    "coords": {
    "lat": "57.15",
    "lon": "65.53333"
    },
    "district": "Уральский",
    "name": "Тюмень",
    "population": 816700,
    "subject": "Тюменская область"
    },
    {
    "coords": {
    "lat": "51.98333",
    "lon": "42.26667"
    },
    "district": "Центральный",
    "name": "Уварово",
    "population": 22916,
    "subject": "Тамбовская область"
    },
    {
    "coords": {
    "lat": "49.06667",
    "lon": "142.03333"
    },
    "district": "Дальневосточный",
    "name": "Углегорск",
    "population": 8443,
    "subject": "Сахалинская область"
    },
    {
    "coords": {
    "lat": "57.53333",
    "lon": "38.33333"
    },
    "district": "Центральный",
    "name": "Углич",
    "population": 31452,
    "subject": "Ярославская область"
    },
    {
    "coords": {
    "lat": "66.4",
    "lon": "112.3"
    },
    "district": "Дальневосточный",
    "name": "Удачный",
    "population": 12198,
    "subject": "Якутия"
    },
    {
    "coords": {
    "lat": "57.88333",
    "lon": "35.01667"
    },
    "district": "Центральный",
    "name": "Удомля",
    "population": 26726,
    "subject": "Тверская область"
    },
    {
    "coords": {
    "lat": "55.31667",
    "lon": "89.81667"
    },
    "district": "Сибирский",
    "name": "Ужур",
    "population": 15221,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "53.9791417",
    "lon": "38.1600833"
    },
    "district": "Центральный",
    "name": "Узловая",
    "population": 49155,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "51.83333",
    "lon": "107.61667"
    },
    "district": "Сибирский",
    "name": "Улан-Удэ",
    "population": 437514,
    "subject": "Бурятия"
    },
    {
    "coords": {
    "lat": "54.31667",
    "lon": "48.36667"
    },
    "district": "Приволжский",
    "name": "Ульяновск",
    "population": 625462,
    "subject": "Ульяновская область"
    },
    {
    "coords": {
    "lat": "52.85",
    "lon": "32.68333"
    },
    "district": "Центральный",
    "name": "Унеча",
    "population": 22565,
    "subject": "Брянская область"
    },
    {
    "coords": {
    "lat": "60.13333",
    "lon": "64.78333"
    },
    "district": "Уральский",
    "name": "Урай",
    "population": 40692,
    "subject": "Ханты-Мансийский АО"
    },
    {
    "coords": {
    "lat": "57.46667",
    "lon": "45.78333"
    },
    "district": "Приволжский",
    "name": "Урень",
    "population": 12289,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "57.11667",
    "lon": "50"
    },
    "district": "Приволжский",
    "name": "Уржум",
    "population": 9703,
    "subject": "Кировская область"
    },
    {
    "coords": {
    "lat": "43.129123",
    "lon": "45.54167"
    },
    "district": "Северо-Кавказский",
    "name": "Урус-Мартан",
    "population": 63955,
    "subject": "Чечня"
    },
    {
    "coords": {
    "lat": "50.8",
    "lon": "42.01667"
    },
    "district": "Южный",
    "name": "Урюпинск",
    "population": 36186,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "65.995028",
    "lon": "57.557139"
    },
    "district": "Северо-Западный",
    "name": "Усинск",
    "population": 37198,
    "subject": "Коми"
    },
    {
    "coords": {
    "lat": "52.05",
    "lon": "39.73333"
    },
    "district": "Центральный",
    "name": "Усмань",
    "population": 19396,
    "subject": "Липецкая область"
    },
    {
    "coords": {
    "lat": "52.75",
    "lon": "103.65"
    },
    "district": "Сибирский",
    "name": "Усолье-Сибирское",
    "population": 75062,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "59.41667",
    "lon": "56.68333"
    },
    "district": "Приволжский",
    "name": "Усолье",
    "population": 6124,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "43.8",
    "lon": "131.95"
    },
    "district": "Дальневосточный",
    "name": "Уссурийск",
    "population": 172942,
    "subject": "Приморский край"
    },
    {
    "coords": {
    "lat": "44.08611",
    "lon": "41.97194"
    },
    "district": "Северо-Кавказский",
    "name": "Усть-Джегута",
    "population": 30758,
    "subject": "Карачаево-Черкесия"
    },
    {
    "coords": {
    "lat": "58",
    "lon": "102.66667"
    },
    "district": "Сибирский",
    "name": "Усть-Илимск",
    "population": 79746,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "54.93333",
    "lon": "58.16667"
    },
    "district": "Уральский",
    "name": "Усть-Катав",
    "population": 21609,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "56.8",
    "lon": "105.83333"
    },
    "district": "Сибирский",
    "name": "Усть-Кут",
    "population": 40281,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "45.21528",
    "lon": "39.68944"
    },
    "district": "Южный",
    "name": "Усть-Лабинск",
    "population": 38565,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "58.83333",
    "lon": "36.43333"
    },
    "district": "Северо-Западный",
    "name": "Устюжна",
    "population": 8284,
    "subject": "Вологодская область"
    },
    {
    "coords": {
    "lat": "54.73333",
    "lon": "55.96667"
    },
    "district": "Приволжский",
    "name": "Уфа",
    "population": 1125933,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "63.56667",
    "lon": "53.7"
    },
    "district": "Северо-Западный",
    "name": "Ухта",
    "population": 92479,
    "subject": "Коми"
    },
    {
    "coords": {
    "lat": "54.31667",
    "lon": "59.38333"
    },
    "district": "Приволжский",
    "name": "Учалы",
    "population": 38112,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "55.81667",
    "lon": "94.31667"
    },
    "district": "Сибирский",
    "name": "Уяр",
    "population": 11932,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "52.08944",
    "lon": "35.85889"
    },
    "district": "Центральный",
    "name": "Фатеж",
    "population": 6135,
    "subject": "Курская область"
    },
    {
    "coords": {
    "lat": "45.04889",
    "lon": "35.37917"
    },
    "district": "Южный",
    "name": "Феодосия",
    "population": 67750,
    "subject": "Крым"
    },
    {
    "coords": {
    "lat": "53.45",
    "lon": "34.41667"
    },
    "district": "Центральный",
    "name": "Фокино",
    "population": 22628,
    "subject": "Брянская область"
    },
    {
    "coords": {
    "lat": "42.96667",
    "lon": "132.4"
    },
    "district": "Дальневосточный",
    "name": "Фокино",
    "population": 12617,
    "subject": "Приморский край"
    },
    {
    "coords": {
    "lat": "49.76667",
    "lon": "43.65"
    },
    "district": "Южный",
    "name": "Фролово",
    "population": 35913,
    "subject": "Волгоградская область"
    },
    {
    "coords": {
    "lat": "55.95",
    "lon": "38.05"
    },
    "district": "Центральный",
    "name": "Фрязино",
    "population": 58938,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "57.25",
    "lon": "41.1"
    },
    "district": "Центральный",
    "name": "Фурманов",
    "population": 32855,
    "subject": "Ивановская область"
    },
    {
    "coords": {
    "lat": "48.48333",
    "lon": "135.06667"
    },
    "district": "Дальневосточный",
    "name": "Хабаровск",
    "population": 610305,
    "subject": "Хабаровский край"
    },
    {
    "coords": {
    "lat": "44.42389",
    "lon": "39.53722"
    },
    "district": "Южный",
    "name": "Хадыженск",
    "population": 22005,
    "subject": "Краснодарский край"
    },
    {
    "coords": {
    "lat": "61",
    "lon": "69"
    },
    "district": "Уральский",
    "name": "Ханты-Мансийск",
    "population": 103117,
    "subject": "Ханты-Мансийский АО — Югра"
    },
    {
    "coords": {
    "lat": "47.4",
    "lon": "47.25"
    },
    "district": "Южный",
    "name": "Харабали",
    "population": 17338,
    "subject": "Астраханская область"
    },
    {
    "coords": {
    "lat": "59.95",
    "lon": "40.2"
    },
    "district": "Северо-Западный",
    "name": "Харовск",
    "population": 8650,
    "subject": "Вологодская область"
    },
    {
    "coords": {
    "lat": "43.25",
    "lon": "46.58333"
    },
    "district": "Северо-Кавказский",
    "name": "Хасавюрт",
    "population": 146394,
    "subject": "Дагестан"
    },
    {
    "coords": {
    "lat": "52.48333",
    "lon": "48.1"
    },
    "district": "Приволжский",
    "name": "Хвалынск",
    "population": 12143,
    "subject": "Саратовская область"
    },
    {
    "coords": {
    "lat": "51.35",
    "lon": "110.45"
    },
    "district": "Сибирский",
    "name": "Хилок",
    "population": 10320,
    "subject": "Забайкальский край"
    },
    {
    "coords": {
    "lat": "55.88917",
    "lon": "37.445"
    },
    "district": "Центральный",
    "name": "Химки",
    "population": 257757,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "57.15",
    "lon": "31.18333"
    },
    "district": "Северо-Западный",
    "name": "Холм",
    "population": 3344,
    "subject": "Новгородская область"
    },
    {
    "coords": {
    "lat": "47.04028",
    "lon": "142.04306"
    },
    "district": "Дальневосточный",
    "name": "Холмск",
    "population": 26672,
    "subject": "Сахалинская область"
    },
    {
    "coords": {
    "lat": "56.25",
    "lon": "37.98333"
    },
    "district": "Центральный",
    "name": "Хотьково",
    "population": 21169,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "55.86667",
    "lon": "47.48333"
    },
    "district": "Приволжский",
    "name": "Цивильск",
    "population": 15049,
    "subject": "Чувашия"
    },
    {
    "coords": {
    "lat": "47.64667",
    "lon": "42.09472"
    },
    "district": "Южный",
    "name": "Цимлянск",
    "population": 14406,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "51.7602528",
    "lon": "128.121175"
    },
    "district": "Дальневосточный",
    "name": "Циолковский",
    "population": 7167,
    "subject": "Амурская область"
    },
    {
    "coords": {
    "lat": "51.28333",
    "lon": "91.56667"
    },
    "district": "Сибирский",
    "name": "Чадан",
    "population": 9519,
    "subject": "Тыва"
    },
    {
    "coords": {
    "lat": "56.773291",
    "lon": "54.140386"
    },
    "district": "Приволжский",
    "name": "Чайковский",
    "population": 81855,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "52.98333",
    "lon": "49.71667"
    },
    "district": "Приволжский",
    "name": "Чапаевск",
    "population": 70944,
    "subject": "Самарская область"
    },
    {
    "coords": {
    "lat": "53.24167",
    "lon": "39.96667"
    },
    "district": "Центральный",
    "name": "Чаплыгин",
    "population": 11674,
    "subject": "Липецкая область"
    },
    {
    "coords": {
    "lat": "54.97778",
    "lon": "60.37"
    },
    "district": "Уральский",
    "name": "Чебаркуль",
    "population": 41516,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "56.11667",
    "lon": "47.23333"
    },
    "district": "Приволжский",
    "name": "Чебоксары",
    "population": 495810,
    "subject": "Чувашия"
    },
    {
    "coords": {
    "lat": "43.566657",
    "lon": "43.583325"
    },
    "district": "Северо-Кавказский",
    "name": "Чегем",
    "population": 18542,
    "subject": "Кабардино-Балкария"
    },
    {
    "coords": {
    "lat": "54.1",
    "lon": "36.25"
    },
    "district": "Центральный",
    "name": "Чекалин",
    "population": 866,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "55.16222",
    "lon": "61.40306"
    },
    "district": "Уральский",
    "name": "Челябинск",
    "population": 1187960,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "60.4",
    "lon": "56.48333"
    },
    "district": "Приволжский",
    "name": "Чердынь",
    "population": 4536,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "53.15",
    "lon": "103.06667"
    },
    "district": "Сибирский",
    "name": "Черемхово",
    "population": 49933,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "54.21667",
    "lon": "83.36667"
    },
    "district": "Сибирский",
    "name": "Черепаново",
    "population": 18846,
    "subject": "Новосибирская область"
    },
    {
    "coords": {
    "lat": "59.11667",
    "lon": "37.9"
    },
    "district": "Северо-Западный",
    "name": "Череповец",
    "population": 312091,
    "subject": "Вологодская область"
    },
    {
    "coords": {
    "lat": "44.213888",
    "lon": "42.04431"
    },
    "district": "Северо-Кавказский",
    "name": "Черкесск",
    "population": 123148,
    "subject": "Карачаево-Черкесия"
    },
    {
    "coords": {
    "lat": "56.01472",
    "lon": "38.38972"
    },
    "district": "Центральный",
    "name": "Черноголовка",
    "population": 20638,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "53.81667",
    "lon": "91.28333"
    },
    "district": "Сибирский",
    "name": "Черногорск",
    "population": 75348,
    "subject": "Хакасия"
    },
    {
    "coords": {
    "lat": "56.5",
    "lon": "56.08333"
    },
    "district": "Приволжский",
    "name": "Чернушка",
    "population": 33308,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "54.63333",
    "lon": "21.81667"
    },
    "district": "Северо-Западный",
    "name": "Черняховск",
    "population": 35375,
    "subject": "Калининградская область"
    },
    {
    "coords": {
    "lat": "55.145",
    "lon": "37.45556"
    },
    "district": "Центральный",
    "name": "Чехов",
    "population": 71077,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "55.36667",
    "lon": "50.63333"
    },
    "district": "Приволжский",
    "name": "Чистополь",
    "population": 58771,
    "subject": "Татарстан"
    },
    {
    "coords": {
    "lat": "52.03333",
    "lon": "113.5"
    },
    "district": "Сибирский",
    "name": "Чита",
    "population": 350861,
    "subject": "Забайкальский край"
    },
    {
    "coords": {
    "lat": "56.76667",
    "lon": "43.25"
    },
    "district": "Приволжский",
    "name": "Чкаловск",
    "population": 11193,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "59.12806",
    "lon": "31.65917"
    },
    "district": "Северо-Западный",
    "name": "Чудово",
    "population": 13764,
    "subject": "Новгородская область"
    },
    {
    "coords": {
    "lat": "55.1",
    "lon": "80.96667"
    },
    "district": "Сибирский",
    "name": "Чулым",
    "population": 10926,
    "subject": "Новосибирская область"
    },
    {
    "coords": {
    "lat": "58.28333",
    "lon": "57.81667"
    },
    "district": "Приволжский",
    "name": "Чусовой",
    "population": 43299,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "58.75",
    "lon": "42.7"
    },
    "district": "Центральный",
    "name": "Чухлома",
    "population": 4906,
    "subject": "Костромская область"
    },
    {
    "coords": {
    "lat": "58.78333",
    "lon": "56.15"
    },
    "district": "Приволжский",
    "name": "Чёрмоз",
    "population": 3215,
    "subject": "Пермский край"
    },
    {
    "coords": {
    "lat": "51.53333",
    "lon": "92.9"
    },
    "district": "Сибирский",
    "name": "Шагонар",
    "population": 11289,
    "subject": "Тыва"
    },
    {
    "coords": {
    "lat": "56.08333",
    "lon": "63.63333"
    },
    "district": "Уральский",
    "name": "Шадринск",
    "population": 74400,
    "subject": "Курганская область"
    },
    {
    "coords": {
    "lat": "43.145",
    "lon": "45.903847"
    },
    "district": "Северо-Кавказский",
    "name": "Шали",
    "population": 56226,
    "subject": "Чечня"
    },
    {
    "coords": {
    "lat": "55.525",
    "lon": "89.2"
    },
    "district": "Сибирский",
    "name": "Шарыпово",
    "population": 36463,
    "subject": "Красноярский край"
    },
    {
    "coords": {
    "lat": "58.36667",
    "lon": "45.5"
    },
    "district": "Центральный",
    "name": "Шарья",
    "population": 23222,
    "subject": "Костромская область"
    },
    {
    "coords": {
    "lat": "55.5776722",
    "lon": "39.5446333"
    },
    "district": "Центральный",
    "name": "Шатура",
    "population": 31310,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "47.7122111",
    "lon": "40.2083694"
    },
    "district": "Южный",
    "name": "Шахты",
    "population": 228816,
    "subject": "Ростовская область"
    },
    {
    "coords": {
    "lat": "57.67472",
    "lon": "46.62083"
    },
    "district": "Приволжский",
    "name": "Шахунья",
    "population": 19591,
    "subject": "Нижегородская область"
    },
    {
    "coords": {
    "lat": "54.03333",
    "lon": "41.7"
    },
    "district": "Центральный",
    "name": "Шацк",
    "population": 5796,
    "subject": "Рязанская область"
    },
    {
    "coords": {
    "lat": "50.40778",
    "lon": "36.89694"
    },
    "district": "Центральный",
    "name": "Шебекино",
    "population": 40352,
    "subject": "Белгородская область"
    },
    {
    "coords": {
    "lat": "52.2",
    "lon": "104.1"
    },
    "district": "Сибирский",
    "name": "Шелехов",
    "population": 48317,
    "subject": "Иркутская область"
    },
    {
    "coords": {
    "lat": "62.1",
    "lon": "42.9"
    },
    "district": "Северо-Западный",
    "name": "Шенкурск",
    "population": 4608,
    "subject": "Архангельская область"
    },
    {
    "coords": {
    "lat": "51.85",
    "lon": "116.03333"
    },
    "district": "Сибирский",
    "name": "Шилка",
    "population": 12339,
    "subject": "Забайкальский край"
    },
    {
    "coords": {
    "lat": "52",
    "lon": "127.66667"
    },
    "district": "Дальневосточный",
    "name": "Шимановск",
    "population": 18513,
    "subject": "Амурская область"
    },
    {
    "coords": {
    "lat": "52.1137809",
    "lon": "47.199229"
    },
    "district": "Приволжский",
    "name": "Шиханы",
    "population": 5230,
    "subject": "Саратовская область"
    },
    {
    "coords": {
    "lat": "59.944959",
    "lon": "31.034754"
    },
    "district": "Северо-Западный",
    "name": "Шлиссельбург",
    "population": 14851,
    "subject": "Ленинградская область"
    },
    {
    "coords": {
    "lat": "55.5",
    "lon": "46.41667"
    },
    "district": "Приволжский",
    "name": "Шумерля",
    "population": 28168,
    "subject": "Чувашия"
    },
    {
    "coords": {
    "lat": "55.23333",
    "lon": "63.28333"
    },
    "district": "Уральский",
    "name": "Шумиха",
    "population": 17141,
    "subject": "Курганская область"
    },
    {
    "coords": {
    "lat": "56.85",
    "lon": "41.36667"
    },
    "district": "Центральный",
    "name": "Шуя",
    "population": 56041,
    "subject": "Ивановская область"
    },
    {
    "coords": {
    "lat": "55.5",
    "lon": "37.56667"
    },
    "district": "Центральный",
    "name": "Щербинка",
    "population": 53974,
    "subject": "Москва"
    },
    {
    "coords": {
    "lat": "51.88111",
    "lon": "36.90306"
    },
    "district": "Центральный",
    "name": "Щигры",
    "population": 14711,
    "subject": "Курская область"
    },
    {
    "coords": {
    "lat": "55.21667",
    "lon": "62.76667"
    },
    "district": "Уральский",
    "name": "Щучье",
    "population": 9346,
    "subject": "Курганская область"
    },
    {
    "coords": {
    "lat": "54",
    "lon": "37.51667"
    },
    "district": "Центральный",
    "name": "Щёкино",
    "population": 56263,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "45.42361",
    "lon": "35.81861"
    },
    "district": "Южный",
    "name": "Щёлкино",
    "population": 10078,
    "subject": "Крым"
    },
    {
    "coords": {
    "lat": "55.91667",
    "lon": "38"
    },
    "district": "Центральный",
    "name": "Щёлково",
    "population": 127292,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "55.88333",
    "lon": "38.78333"
    },
    "district": "Центральный",
    "name": "Электрогорск",
    "population": 22439,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "55.8",
    "lon": "38.45"
    },
    "district": "Центральный",
    "name": "Электросталь",
    "population": 152607,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "55.71667",
    "lon": "38.21667"
    },
    "district": "Центральный",
    "name": "Электроугли",
    "population": 20607,
    "subject": "Московская область"
    },
    {
    "coords": {
    "lat": "46.31667",
    "lon": "44.26667"
    },
    "district": "Южный",
    "name": "Элиста",
    "population": 103535,
    "subject": "Калмыкия"
    },
    {
    "coords": {
    "lat": "51.46667",
    "lon": "46.11667"
    },
    "district": "Приволжский",
    "name": "Энгельс",
    "population": 226143,
    "subject": "Саратовская область"
    },
    {
    "coords": {
    "lat": "51.83333",
    "lon": "40.8"
    },
    "district": "Центральный",
    "name": "Эртиль",
    "population": 9935,
    "subject": "Воронежская область"
    },
    {
    "coords": {
    "lat": "61.31667",
    "lon": "63.35"
    },
    "district": "Уральский",
    "name": "Югорск",
    "population": 38544,
    "subject": "Ханты-Мансийский АО"
    },
    {
    "coords": {
    "lat": "56.58333",
    "lon": "42.01667"
    },
    "district": "Центральный",
    "name": "Южа",
    "population": 12011,
    "subject": "Ивановская область"
    },
    {
    "coords": {
    "lat": "46.95",
    "lon": "142.73333"
    },
    "district": "Дальневосточный",
    "name": "Южно-Сахалинск",
    "population": 200235,
    "subject": "Сахалинская область"
    },
    {
    "coords": {
    "lat": "44.66667",
    "lon": "45.65"
    },
    "district": "Северо-Кавказский",
    "name": "Южно-Сухокумск",
    "population": 10803,
    "subject": "Дагестан"
    },
    {
    "coords": {
    "lat": "54.45",
    "lon": "61.25"
    },
    "district": "Уральский",
    "name": "Южноуральск",
    "population": 37484,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "55.73333",
    "lon": "84.9"
    },
    "district": "Сибирский",
    "name": "Юрга",
    "population": 80367,
    "subject": "Кемеровская область"
    },
    {
    "coords": {
    "lat": "56.5",
    "lon": "39.68333"
    },
    "district": "Центральный",
    "name": "Юрьев-Польский",
    "population": 17616,
    "subject": "Владимирская область"
    },
    {
    "coords": {
    "lat": "57.31667",
    "lon": "43.1"
    },
    "district": "Центральный",
    "name": "Юрьевец",
    "population": 7837,
    "subject": "Ивановская область"
    },
    {
    "coords": {
    "lat": "54.86667",
    "lon": "58.43333"
    },
    "district": "Уральский",
    "name": "Юрюзань",
    "population": 10686,
    "subject": "Челябинская область"
    },
    {
    "coords": {
    "lat": "54.75",
    "lon": "35.23333"
    },
    "district": "Центральный",
    "name": "Юхнов",
    "population": 5726,
    "subject": "Калужская область"
    },
    {
    "coords": {
    "lat": "55.95",
    "lon": "46.2"
    },
    "district": "Приволжский",
    "name": "Ядрин",
    "population": 8089,
    "subject": "Чувашия"
    },
    {
    "coords": {
    "lat": "62.02722",
    "lon": "129.73194"
    },
    "district": "Дальневосточный",
    "name": "Якутск",
    "population": 330615,
    "subject": "Якутия"
    },
    {
    "coords": {
    "lat": "44.49944",
    "lon": "34.15528"
    },
    "district": "Южный",
    "name": "Ялта",
    "population": 78171,
    "subject": "Крым"
    },
    {
    "coords": {
    "lat": "56.65",
    "lon": "66.3"
    },
    "district": "Уральский",
    "name": "Ялуторовск",
    "population": 39947,
    "subject": "Тюменская область"
    },
    {
    "coords": {
    "lat": "56.26667",
    "lon": "54.93333"
    },
    "district": "Приволжский",
    "name": "Янаул",
    "population": 24805,
    "subject": "Башкортостан"
    },
    {
    "coords": {
    "lat": "57.303306",
    "lon": "47.868806"
    },
    "district": "Приволжский",
    "name": "Яранск",
    "population": 15279,
    "subject": "Кировская область"
    },
    {
    "coords": {
    "lat": "52.93333",
    "lon": "78.58333"
    },
    "district": "Сибирский",
    "name": "Яровое",
    "population": 17939,
    "subject": "Алтайский край"
    },
    {
    "coords": {
    "lat": "57.61667",
    "lon": "39.85"
    },
    "district": "Центральный",
    "name": "Ярославль",
    "population": 601403,
    "subject": "Ярославская область"
    },
    {
    "coords": {
    "lat": "55.06667",
    "lon": "32.68333"
    },
    "district": "Центральный",
    "name": "Ярцево",
    "population": 42385,
    "subject": "Смоленская область"
    },
    {
    "coords": {
    "lat": "54.4793833",
    "lon": "37.6933556"
    },
    "district": "Центральный",
    "name": "Ясногорск",
    "population": 14984,
    "subject": "Тульская область"
    },
    {
    "coords": {
    "lat": "51.03333",
    "lon": "59.86667"
    },
    "district": "Приволжский",
    "name": "Ясный",
    "population": 15092,
    "subject": "Оренбургская область"
    },
    {
    "coords": {
    "lat": "56.28333",
    "lon": "37.48333"
    },
    "district": "Центральный",
    "name": "Яхрома",
    "population": 13818,
    "subject": "Московская область"
    }
];